// @generated by liquid-inject from src/sections/algolia-main-collection/algolia-main-collection.ts
// src/shared/algolia-page/constants.ts
var ALGOLIA_HITS_PER_PAGE = 48;
var ALGOLIA_MAX_INITIAL_PRELOAD_PAGES = 3;
var ALGOLIA_MAX_VALUES_PER_FACET = 50;
var ALGOLIA_METAOBJECT_FACET_ATTRIBUTES = [
  "meta.custom.capacity._id",
  "meta.custom.format._id",
  "meta.custom.product_tags._id"
];
var ALGOLIA_METAOBJECT_TEXT_FACET_ATTRIBUTES = [
  "meta.custom.capacity.fields.value",
  "meta.custom.format.fields.value",
  "meta.custom.product_tags.fields.name"
];

// src/shared/algolia-page/facets.ts
import {
  localizedMetaobjectLabel
} from "@theme/algolia-shared";
function isHiddenFacet(attribute, hidden) {
  const normalizedAttribute = attribute.trim();
  return hidden.some((entry) => entry === normalizedAttribute);
}
function parseHiddenFacets(value) {
  return (value ?? "").split(",").map((entry) => entry.trim()).filter(Boolean);
}
function parsePairs(value) {
  return value.split(",").map((item) => item.trim()).filter(Boolean).map((entry) => {
    const colonIndex = entry.indexOf(":");
    if (colonIndex === -1) {
      return {
        value: entry,
        label: (entry.split(".").pop() ?? entry).replace(/_/g, " ")
      };
    }
    return {
      value: entry.slice(0, colonIndex).trim(),
      label: entry.slice(colonIndex + 1).trim()
    };
  });
}
var STRUCTURAL_ATTRIBUTE_SEGMENTS = /* @__PURE__ */ new Set([
  "_id",
  "_type",
  "fields",
  "name",
  "value"
]);
function labelFromAttr(attribute) {
  const segments = attribute.split(".");
  while (segments.length > 1 && STRUCTURAL_ATTRIBUTE_SEGMENTS.has(segments[segments.length - 1])) {
    segments.pop();
  }
  return segments.pop().replace(/_/g, " ").replace(/\b\w/g, (character) => character.toUpperCase());
}
function facetSortBy(attribute) {
  return isPriceRangeFacet(attribute) ? ["name:asc"] : ["count:desc", "name:asc"];
}
function isPriceRangeFacet(attribute) {
  if (!attribute) return false;
  const normalizedAttribute = attribute.toLowerCase().replace(/_/g, "-");
  return normalizedAttribute.includes("price") && normalizedAttribute.includes("range");
}
function currencyCode() {
  return window.currencyIsoCode || window.Shopify?.currency?.active || "EUR";
}
function currencySymbol() {
  const currency = currencyCode();
  try {
    return new Intl.NumberFormat(document.documentElement.lang || "fr-FR", {
      currency,
      currencyDisplay: "narrowSymbol",
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
      style: "currency"
    }).formatToParts(0).find((part) => part.type === "currency")?.value ?? currency;
  } catch {
    return currency;
  }
}
function formatPriceRangeAmount(value) {
  const numericValue = Number(value.replace(",", "."));
  if (!Number.isFinite(numericValue)) return value;
  const amount = new Intl.NumberFormat(
    document.documentElement.lang || "fr-FR",
    {
      maximumFractionDigits: 2,
      minimumFractionDigits: 0
    }
  ).format(numericValue);
  return `${amount}${currencySymbol()}`;
}
function formatPriceRangeValue(value) {
  const rawValue = String(value ?? "");
  const amounts = rawValue.match(/\d+(?:[.,]\d+)?/g);
  if (!amounts || amounts.length < 2) return rawValue;
  return `${formatPriceRangeAmount(amounts[0])} - ${formatPriceRangeAmount(
    amounts[1]
  )}`;
}
var CAPACITY_UNIT_FACTORS = {
  cl: 10,
  g: 1,
  kg: 1e3,
  l: 1e3,
  mg: 1e-3,
  ml: 1
};
var CAPACITY_AMOUNT = /(\d+(?:[.,]\d+)?)\s*(mg|kg|cl|ml|g|l)\b/gi;
function capacityMagnitude(label) {
  const trimmedLabel = label.trim();
  if (!/^\d/.test(trimmedLabel)) return null;
  const amounts = [...trimmedLabel.matchAll(CAPACITY_AMOUNT)];
  const lastAmount = amounts[amounts.length - 1];
  const rawNumber = lastAmount ? lastAmount[1] : trimmedLabel.match(/\d+(?:[.,]\d+)?/)?.[0] ?? "";
  const quantity = Number(rawNumber.replace(",", "."));
  if (!Number.isFinite(quantity)) return null;
  return quantity * (CAPACITY_UNIT_FACTORS[lastAmount?.[2]?.toLowerCase() ?? ""] ?? 1);
}
function parseCapacityOrder(value) {
  return value?.trim().toLowerCase() === "asc" ? "asc" : "desc";
}
function sortByCapacity(items, order) {
  const measuredItems = items.map((item) => ({
    item,
    magnitude: capacityMagnitude(item.label)
  }));
  const measuredCount = measuredItems.filter(
    (entry) => entry.magnitude !== null
  ).length;
  if (measuredCount < 2 || measuredCount * 2 <= items.length) return items;
  const direction = order === "asc" ? -1 : 1;
  return measuredItems.sort((firstEntry, secondEntry) => {
    if (firstEntry.magnitude === null)
      return secondEntry.magnitude === null ? 0 : 1;
    if (secondEntry.magnitude === null) return -1;
    return (secondEntry.magnitude - firstEntry.magnitude) * direction;
  }).map((entry) => entry.item);
}
function priceRangeStart(value) {
  const rawValue = String(value ?? "");
  const amount = rawValue.match(/\d+(?:[.,]\d+)?/);
  if (!amount) return Number.POSITIVE_INFINITY;
  const numericValue = Number(amount[0].replace(",", "."));
  return Number.isFinite(numericValue) ? numericValue : Number.POSITIVE_INFINITY;
}
function formatTextFacetLabel(label) {
  const rawLabel = String(label ?? "").trim();
  if (!rawLabel) return "";
  const readableRawLabel = collapseRepeatedLabel(rawLabel);
  const readableLabel = readableRawLabel.replace(/[-_]+/g, " ");
  return readableLabel.charAt(0).toUpperCase() + readableLabel.slice(1);
}
function collapseRepeatedLabel(label) {
  const normalizedLabel = label.toLowerCase();
  for (let chunkLength = 1; chunkLength <= label.length / 2; chunkLength += 1) {
    if (label.length % chunkLength !== 0) continue;
    const normalizedChunk = normalizedLabel.slice(0, chunkLength);
    const repeatCount = label.length / chunkLength;
    let isRepeated = repeatCount > 1;
    for (let index = 1; index < repeatCount; index += 1) {
      const chunkStart = index * chunkLength;
      const chunkEnd = chunkStart + chunkLength;
      if (normalizedLabel.slice(chunkStart, chunkEnd) !== normalizedChunk) {
        isRepeated = false;
        break;
      }
    }
    if (isRepeated) return label.slice(0, chunkLength).trim();
  }
  return label;
}
var METAOBJECT_GID = /^gid:\/\/shopify\/Metaobject\/\d+$/;
function metaobjectFacetLabel(value) {
  if (typeof value !== "string" || !METAOBJECT_GID.test(value)) return null;
  return localizedMetaobjectLabel(value);
}
function formatFacetLabel(attribute, label, value) {
  const metaobjectLabel = metaobjectFacetLabel(value ?? label);
  if (metaobjectLabel !== null) return metaobjectLabel;
  if (attribute && ALGOLIA_METAOBJECT_TEXT_FACET_ATTRIBUTES.includes(attribute)) {
    return String(label ?? "").trim();
  }
  if (!isPriceRangeFacet(attribute)) return formatTextFacetLabel(label);
  return formatPriceRangeValue(value ?? label);
}
function formatFacetItems(attribute, items, capacityOrder = "desc") {
  const formattedItems = items.map((item) => {
    const label = formatFacetLabel(attribute, item.label, item.value);
    return {
      ...item,
      highlighted: label,
      label
    };
  }).filter((item) => item.label !== "");
  if (!isPriceRangeFacet(attribute))
    return sortByCapacity(formattedItems, capacityOrder);
  return formattedItems.sort(
    (firstItem, secondItem) => priceRangeStart(firstItem.value ?? firstItem.label) - priceRangeStart(secondItem.value ?? secondItem.label)
  );
}

// src/shared/utils/section-render.ts
var SECTION_PREFIX = "shopify-section-";
function getSectionId(el) {
  if (!el?.id?.startsWith(SECTION_PREFIX)) return null;
  return el.id.slice(SECTION_PREFIX.length);
}
function closestSectionId(el) {
  const wrapper = el?.closest(`[id^="${SECTION_PREFIX}"]`);
  return getSectionId(wrapper);
}
function collectSectionIds(elements) {
  const ids = /* @__PURE__ */ new Set();
  for (const el of elements) {
    const id = closestSectionId(el);
    if (id) ids.add(id);
  }
  return [...ids];
}
function buildUrl(base, params) {
  const url = new URL(base ?? window.location.pathname, window.location.origin);
  for (const [key, value] of Object.entries(params)) {
    url.searchParams.set(key, value);
  }
  return url.toString();
}
function withQuery(params, query) {
  if (!query) return params;
  const extra = Object.fromEntries(
    Object.entries(query).map(([k, v]) => [k, String(v)])
  );
  return { ...extra, ...params };
}
async function fetchSections(ids, options = {}) {
  const url = buildUrl(
    options.url,
    withQuery({ sections: ids.join(",") }, options.query)
  );
  const response = await fetch(url, { credentials: "same-origin" });
  if (!response.ok) throw new Error(`Sections fetch ${response.status}`);
  return response.json();
}
async function fetchSectionHTML(id, options = {}) {
  const url = buildUrl(
    options.url,
    withQuery({ section_id: id }, options.query)
  );
  const response = await fetch(url, { credentials: "same-origin" });
  if (!response.ok) throw new Error(`Section fetch ${response.status}`);
  return response.text();
}
function swapInner(html, selector) {
  const selectors = Array.isArray(selector) ? selector : [selector];
  const doc = new DOMParser().parseFromString(html, "text/html");
  selectors.forEach((sel) => {
    document.querySelectorAll(sel).forEach((element) => {
      const source = element.dataset.id ? doc.querySelector(`${sel}[data-id="${element.dataset.id}"]`) : doc.querySelector(sel);
      if (source) element.innerHTML = source.innerHTML;
    });
  });
}
function swapSection(id, html) {
  const live = document.getElementById(`${SECTION_PREFIX}${id}`);
  if (!live) return;
  const doc = new DOMParser().parseFromString(html, "text/html");
  const next = doc.getElementById(`${SECTION_PREFIX}${id}`) || doc.body.firstElementChild;
  if (next instanceof HTMLElement) {
    live.replaceWith(next);
  } else {
    live.hidden = true;
  }
}
async function renderSections(targets, options = {}) {
  if (targets.length === 0) return;
  const map = options.sections ?? await fetchSections(
    targets.map((t) => t.id),
    options
  );
  for (const target of targets) {
    const html = map[target.id];
    if (typeof html !== "string") continue;
    if (target.selector) {
      swapInner(html, target.selector);
    } else {
      swapSection(target.id, html);
    }
  }
}
async function renderSection(target, options = {}) {
  const html = await fetchSectionHTML(target.id, options);
  if (target.selector) {
    swapInner(html, target.selector);
  } else {
    swapSection(target.id, html);
  }
}

// src/shared/cart-limit-error/cart-limit-error.ts
var ERROR_MESSAGE_SELECTOR = "[data-cart-limit-error-message]";
var ERROR_TEXT_SELECTOR = "[data-cart-limit-error-text]";
var OPEN_ENGRAVING_PANEL_SELECTOR = "c-engraving-panel.is-open";
var SEARCH_DIALOG_SELECTOR = "dialog[data-search-dialog]";
var QUANTITY_LIMIT_PATTERNS = [
  /can'?t add more/i,
  /maximum allowed quantity/i,
  /maximum quantity/i,
  /quantity.*exceeded/i,
  /only add \d+/i
];
function getErrorMessageEl() {
  return document.querySelector(ERROR_MESSAGE_SELECTOR);
}
function getDefaultMessage() {
  return window.cartStrings?.addToCartLimitError ?? "The maximum allowed quantity for this product has been exceeded.";
}
function isCartQuantityLimitError(status, description) {
  if (status !== 422) return false;
  const normalized = description.trim();
  if (normalized.length === 0) return true;
  return QUANTITY_LIMIT_PATTERNS.some((pattern) => pattern.test(normalized));
}
function closeOpenEngravingPanels() {
  document.querySelectorAll(OPEN_ENGRAVING_PANEL_SELECTOR).forEach((panel) => {
    ;
    panel.close();
  });
}
function closeHeaderSearchIfOpen() {
  const openDialogs = document.querySelectorAll(
    `${SEARCH_DIALOG_SELECTOR}[open]`
  );
  if (openDialogs.length === 0) return;
  document.documentElement.classList.remove("is-overflow-hidden");
  openDialogs.forEach((dialog) => {
    dialog.close();
  });
}
function showCartLimitError(message) {
  closeHeaderSearchIfOpen();
  const errorMessage = getErrorMessageEl();
  if (!errorMessage) return;
  const textEl = errorMessage.querySelector(ERROR_TEXT_SELECTOR);
  if (textEl) {
    textEl.textContent = message ?? getDefaultMessage();
  }
  errorMessage.classList.remove("hidden");
  errorMessage.removeAttribute("hidden");
  errorMessage.setAttribute("aria-hidden", "false");
  closeOpenEngravingPanels();
  window.scrollTo(0, 0);
}
function hideCartLimitError() {
  const errorMessage = getErrorMessageEl();
  if (!errorMessage) return;
  const textEl = errorMessage.querySelector(ERROR_TEXT_SELECTOR);
  if (textEl) {
    textEl.textContent = "";
  }
  errorMessage.classList.add("hidden");
  errorMessage.setAttribute("hidden", "");
  errorMessage.setAttribute("aria-hidden", "true");
}

// src/shared/cart-a11y/cart-a11y.ts
var CART_LIVE_STATUS_ID = "cart-live-status";
var FOCUS_ANNOUNCE_DELAY_MS = 300;
function getOrCreateCartLiveRegion() {
  let region = document.getElementById(CART_LIVE_STATUS_ID);
  if (region instanceof HTMLElement) {
    return region;
  }
  region = document.createElement("div");
  region.id = CART_LIVE_STATUS_ID;
  region.className = "sr-only form-status";
  region.setAttribute("role", "status");
  region.setAttribute("aria-live", "polite");
  region.setAttribute("aria-atomic", "true");
  document.body.appendChild(region);
  return region;
}
function announceCartStatus(message, options = {}) {
  const trimmed = message.trim();
  if (!trimmed) return;
  const shouldFocus = options.focus !== false;
  const region = getOrCreateCartLiveRegion();
  if (shouldFocus) {
    region.setAttribute("aria-live", "off");
    region.setAttribute("tabindex", "-1");
    region.textContent = trimmed;
    region.focus({ preventScroll: true });
    window.setTimeout(() => {
      region.setAttribute("aria-live", "polite");
    }, FOCUS_ANNOUNCE_DELAY_MS);
    return;
  }
  region.textContent = "";
  requestAnimationFrame(() => {
    region.textContent = trimmed;
  });
}
function fillCartStatusTemplate(template, values) {
  let result = template;
  if (values.title !== void 0) {
    result = result.replace(/__TITLE__/g, values.title);
  }
  if (values.quantity !== void 0) {
    result = result.replace(/__QUANTITY__/g, String(values.quantity));
  }
  return result;
}

// src/shared/insights/algolia-insights.ts
var ENDPOINT = "https://insights.algolia.io/1/events";
var AGENT = "diptyque-theme";
var TOKEN_KEY = "algolia_user_token";
var PIXEL_CONFIG_KEY = "algolia_config";
var PIXEL_CLICK_KEY = "algolia_analytics_clicked_objects";
var PIXEL_CLICK_MAX = 50;
var MAX_OBJECT_IDS = 20;
var THEME_EMITS_ADD_TO_CART = true;
var OBJECT_ID_SELECTOR = "[data-algolia-object-id]";
var CLICK_HOOKS = "[data-algolia-click], [data-algolia-convert]";
function readConfig() {
  const data = document.body?.dataset;
  if (!data?.algoliaAppId || !data.algoliaApiKey || !data.algoliaIndex) {
    return null;
  }
  return {
    appId: data.algoliaAppId,
    apiKey: data.algoliaApiKey,
    index: data.algoliaIndex
  };
}
function readStorage(key) {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}
function writeStorage(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch {
  }
}
function randomUserToken() {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return `anonymous-${Array.from(
    bytes,
    (byte) => byte.toString(36).padStart(2, "0")
  ).join("")}`;
}
var cachedUserToken = null;
function userToken() {
  if (cachedUserToken) return cachedUserToken;
  const stored = readStorage(TOKEN_KEY);
  cachedUserToken = stored || randomUserToken();
  if (!stored) writeStorage(TOKEN_KEY, cachedUserToken);
  return cachedUserToken;
}
function authenticatedUserToken() {
  return document.body?.dataset.algoliaAuthenticatedUserToken || void 0;
}
function normalizeObjectIDs(values) {
  const ids = /* @__PURE__ */ new Set();
  for (const value of values) {
    const id = String(value ?? "").trim();
    if (id) ids.add(id);
  }
  return Array.from(ids).slice(0, MAX_OBJECT_IDS);
}
function send(config, event) {
  const params = new URLSearchParams({
    "X-Algolia-Application-Id": config.appId,
    "X-Algolia-API-Key": config.apiKey,
    "X-Algolia-Agent": AGENT
  });
  const url = `${ENDPOINT}?${params}`;
  const body = JSON.stringify({ events: [event] });
  if (navigator.sendBeacon?.(url, body)) return;
  void fetch(url, { method: "POST", body, keepalive: true }).catch(() => {
  });
}
function track(config, objectIDs, event) {
  if (objectIDs.length === 0) return;
  send(config, {
    ...event,
    index: config.index,
    objectIDs,
    userToken: userToken(),
    authenticatedUserToken: authenticatedUserToken()
  });
}
function writePixelConfig(config) {
  writeStorage(
    PIXEL_CONFIG_KEY,
    JSON.stringify({
      app_id: config.appId,
      search_api_key: config.apiKey,
      index_name: config.index,
      user_token: userToken()
    })
  );
}
function recordClickForPixel(config, objectIDs, productId) {
  const stored = readStorage(PIXEL_CLICK_KEY);
  let records = [];
  try {
    const parsed = stored ? JSON.parse(stored) : [];
    if (Array.isArray(parsed)) records = parsed;
  } catch {
    records = [];
  }
  records.push({ index: config.index, objectIDs, productId });
  writeStorage(PIXEL_CLICK_KEY, JSON.stringify(records.slice(-PIXEL_CLICK_MAX)));
}
function readObjectId(element) {
  const above = element?.closest(OBJECT_ID_SELECTOR);
  if (above?.dataset.algoliaObjectId) return above.dataset.algoliaObjectId;
  const inside = element?.querySelector(OBJECT_ID_SELECTOR);
  return inside?.dataset.algoliaObjectId ?? "";
}
function readProductId(element) {
  const above = element?.closest("[data-algolia-product-id]");
  if (above?.dataset.algoliaProductId) return above.dataset.algoliaProductId;
  const inside = element?.querySelector(
    "[data-algolia-product-id]"
  );
  return inside?.dataset.algoliaProductId ?? "";
}
function onDocumentClick(event) {
  const target = event.target;
  if (!(target instanceof Element)) return;
  const hook = target.closest(CLICK_HOOKS);
  if (!hook) return;
  const config = readConfig();
  if (!config) return;
  const objectIDs = normalizeObjectIDs([readObjectId(hook)]);
  if (objectIDs.length === 0) return;
  writePixelConfig(config);
  recordClickForPixel(config, objectIDs, readProductId(hook));
  if (hook.matches("[data-algolia-convert]")) return;
  track(config, objectIDs, { eventType: "click", eventName: "Product Clicked" });
}
function onCartAddSuccess(event) {
  if (!THEME_EMITS_ADD_TO_CART) return;
  const target = event.target;
  if (!(target instanceof Element)) return;
  const config = readConfig();
  if (!config) return;
  const objectIDs = normalizeObjectIDs([readObjectId(target)]);
  if (objectIDs.length === 0) return;
  writePixelConfig(config);
  track(config, objectIDs, {
    eventType: "conversion",
    eventSubtype: "addToCart",
    eventName: "Add To Cart"
  });
}
function initAlgoliaInsights() {
  if (typeof window === "undefined" || window.algoliaInsightsReady) return;
  window.algoliaInsightsReady = true;
  document.addEventListener("click", onDocumentClick, true);
  document.addEventListener("cart:add-success", onCartAddSuccess);
}

// src/snippets/product-form/product-form.ts
var TECHNICAL_ERROR_PATTERN = /parameter/i;
var STOCK_LIMIT_PATTERN = /due to availability/i;
var DEFAULT_CART_ERROR = "There was an error while updating your cart. Please try again.";
var CartRequestError = class extends Error {
  constructor(status, technical, lineKeys, message) {
    super(message);
    this.status = status;
    this.technical = technical;
    this.lineKeys = lineKeys;
  }
};
function namedLineKeys(formData) {
  return [...formData.keys()].flatMap(
    (name) => /^updates\[(.+)\]$/.exec(name)?.[1] ?? []
  );
}
var CProductForm = class extends HTMLElement {
  constructor() {
    super(...arguments);
    this.SELECTORS = {
      form: "form",
      submitButton: 'button[type="submit"]',
      updatesInput: 'input[name^="updates["]',
      // Champ `updates[…]` que les boutons `+` / `−` ne touchent pas : la ligne
      // cadeau, dont la quantité est fixée à 1 par le Liquid.
      qtyFixedInput: "[data-qty-fixed]",
      qtyButton: "[data-qty-btn]",
      notifyMeButton: "[data-notify-me-button]",
      notifyWidget: '.gw-float-widget[type="button"]',
      loaderId: "full-page-loader",
      cartRecommendRoot: "[data-cart-recommend-root]",
      // Section `cart-samples` : ancre stable du wrapper + les deux blocs internes.
      samplesSection: "[data-samples-section]",
      samplesRoot: "[data-cart-samples]",
      packagingRoot: "[data-cart-packaging]",
      // Targets re-render via l'Ajax Section Rendering API.
      giftLine: "[data-gift-line]",
      headerCartLink: ".header__action-link--cart",
      popupAtcContainer: "[data-popup-atc-container]",
      cartItems: "[data-cart-items]",
      // Cartes du panier, ancrées à leur clé de ligne — voir `restoreCartOrder`.
      cartLine: "[data-cart-items] [data-line-key]",
      engravingPanelCart: ".engraving-panel-container-cart",
      cartSummary: "[data-cart-summary]",
      // Wrapper `#shopify-section-…` de la section cart-summary : présent même
      // quand le panier est vide (le contenu interne, lui, est conditionné par
      // `cart.item_count`), donc plus fiable que `[data-cart-summary]` pour
      // retrouver l'id de section.
      cartSummarySection: ".section-cart-summary"
    };
    // Initialisés ici et non dans le constructeur : `readDom()` les remplit au
    // premier usage, quand les enfants et les attributs existent enfin.
    this.form = null;
    this.countCartItems = null;
    this.formId = null;
    this.btnSubmit = null;
    this.btnSubmitAlreadyInfos = null;
    this.type = null;
    this.isCart = null;
    this.itemKey = null;
    this.action = "add";
    this.errorMessages = {};
    this.quantitySnapshot = null;
    this.samplesSectionId = null;
    this.sectionsRenderSamples = [];
    this.sectionsRender = [];
    this.hasConnected = false;
    this.submitForm = async () => {
      if (!this.form) return;
      this.clearCartError();
      const hiddenElements = Array.from(
        this.form.querySelectorAll("input, select, textarea")
      ).filter(
        (el) => el.offsetParent === null && el.type !== "hidden"
      );
      hiddenElements.forEach((el) => {
        el.disabled = true;
      });
      const formData = new FormData(this.form);
      hiddenElements.forEach((el) => {
        el.disabled = false;
      });
      const config = this.fetchConfig("javascript");
      const targets = this.withGiftLineTarget(
        this.isCart ? this.getCartPageTargets() : this.sectionsRender
      );
      const sectionsParam = targets.map((target) => target.id).join(",");
      formData.set("sections", sectionsParam);
      if (this.action === "change" && this.itemKey) {
        const properties = {};
        for (const [key, value] of formData.entries()) {
          if (key.includes("properties")) {
            const propKey = key.match(/\[(.*?)\]/g)?.pop()?.replace(/[[\]]/g, "");
            if (propKey) properties[propKey] = value;
          }
        }
        config.body = JSON.stringify({
          id: this.itemKey,
          properties,
          sections: sectionsParam
        });
      } else {
        config.body = formData;
        delete config.headers["Content-Type"];
      }
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      try {
        const endpoints = {
          add: "cart/add.js",
          change: "cart/change.js",
          update: "cart/update.js",
          remove: "cart/update.js",
          // Monter d'un cran est un simple ajout, que la Cart Transform fusionne
          // avec les lignes en place. Descendre n'a pas d'endpoint — voir
          // `setVirtualSetQuantity` juste en dessous.
          add_virtual_set: "cart/add.js"
        };
        const endpoint = endpoints[this.action] ?? endpoints["add"];
        if (this.action === "set_virtual_set") {
          await this.setVirtualSetQuantity(formData, sectionsParam, targets);
          return;
        }
        const response = await fetch(
          (window.Shopify?.routes?.root || "/") + endpoint,
          config
        );
        if (!response.ok) {
          throw await this.readCartError(
            response,
            this.action === "change" && this.itemKey ? [this.itemKey] : namedLineKeys(formData)
          );
        }
        const data = await response.json();
        hideCartLimitError();
        this.quantitySnapshot = null;
        const statusAnnouncement = this.buildCartMutationAnnouncement();
        await renderSections(targets, { sections: data.sections });
        if (statusAnnouncement) {
          announceCartStatus(statusAnnouncement);
        }
        this.dispatchEvent(
          new CustomEvent("cart:add-success", {
            bubbles: true,
            detail: { data, action: this.action }
          })
        );
        if (this.isCart) {
          this.renderSampleSection();
          await this.rerenderCartRecommendSections();
        }
      } catch (error) {
        const removal = this.isLineRemoval();
        const removalAnnouncement = removal ? this.buildCartMutationAnnouncement() : null;
        this.restoreQuantitySnapshot();
        console.error(error.message);
        if (this.isCart) await this.resyncCartPage(targets);
        if (!(error instanceof CartRequestError)) return;
        if (removal && this.isCart && !this.isLineShown(this.itemKey)) {
          if (removalAnnouncement) announceCartStatus(removalAnnouncement);
          return;
        }
        this.showCartError(error);
      }
    };
  }
  /**
   * Resolves the element's children and attributes, on demand.
   *
   * This used to run in the constructor, which is the one place it cannot: a
   * custom element constructor executes at `createElement` / at the opening tag,
   * **before any child or attribute exists**. The component only ever worked
   * because its definition happened to arrive *after* the subtree was complete,
   * so the upgrade replayed the constructor on a finished element — an accident
   * of load order, not a guarantee. The day an entry point imported this module
   * eagerly, the definition landed first and every field below came out null:
   * no submit listener, and quick-buy fell back to a native POST that navigated
   * to /cart instead of adding over AJAX.
   *
   * `connectedCallback` is no better on its own — for server-rendered HTML it
   * fires on the opening tag, also before the children. So the reads happen
   * here, called from the delegated handlers at interaction time, when the
   * subtree is complete whichever way it was built.
   *
   * Idempotent and cheap; re-resolving picks up a subtree the theme editor or a
   * section re-render swapped underneath us.
   */
  readDom() {
    this.form = this.querySelector(this.SELECTORS.form);
    this.countCartItems = this.dataset.countCartItems || null;
    this.formId = this.form?.id || null;
    this.btnSubmit = this.querySelector(this.SELECTORS.submitButton);
    this.btnSubmitAlreadyInfos = document.querySelector(
      `button[form="${this.formId}"]`
    );
    this.type = this.dataset.type || null;
    this.isCart = this.dataset.isCart || (document.body.classList.contains("body--cart") ? "true" : null);
    this.itemKey = this.dataset.itemKey || null;
    this.action = this.dataset.action || "add";
    this.errorMessages = {
      error_product_gift_cart: this.dataset.errorProductGiftCart || ""
    };
    this.samplesSectionId = this.getSamplesSectionId();
    this.sectionsRenderSamples = this.samplesSectionId ? [
      {
        id: this.samplesSectionId,
        selector: [
          this.SELECTORS.samplesRoot,
          this.SELECTORS.packagingRoot
        ]
      }
    ] : [];
    this.sectionsRender = [
      { id: "header", selector: [this.SELECTORS.headerCartLink] },
      { id: "popup-add-to-cart", selector: [this.SELECTORS.popupAtcContainer] }
    ];
  }
  getSamplesSectionId() {
    const sectionChild = document.querySelector(this.SELECTORS.samplesSection);
    return closestSectionId(sectionChild);
  }
  getCartSummarySectionId() {
    return closestSectionId(
      document.querySelector(this.SELECTORS.cartSummarySection)
    ) ?? closestSectionId(document.querySelector(this.SELECTORS.cartSummary));
  }
  // Page panier éclatée en plusieurs sections empilées. Les ids sont résolus au
  // moment du submit (et non dans le constructeur) : le wrapper cart-summary
  // peut être absent ou remplacé entre deux mutations du panier, et l'id réel
  // dépend de templates/cart.json (l'éditeur de thème peut le suffixer).
  getCartPageTargets() {
    const cartSummarySectionId = this.getCartSummarySectionId();
    return [
      { id: "header", selector: [this.SELECTORS.headerCartLink] },
      { id: "popup-add-to-cart", selector: [this.SELECTORS.popupAtcContainer] },
      {
        id: "main-cart",
        selector: [this.SELECTORS.cartItems, this.SELECTORS.engravingPanelCart]
      },
      // Outer swap (pas de `selector`) : le contenu de cart-summary est gated
      // par `cart.item_count`, un inner swap ne saurait pas passer de vide à
      // non-vide (et inversement).
      ...cartSummarySectionId ? [{ id: cartSummarySectionId }] : []
    ];
  }
  /**
   * Ajoute la ligne cadeau de CE formulaire aux cibles de re-rendu.
   *
   * Un produit ouvre droit à un cadeau, et le Liquid tranche au rendu — mais
   * après un ajout, seuls le header et le popup reviennent : le formulaire
   * resté à l'écran garderait ses inputs cadeau et en servirait un second au
   * clic suivant. On redemande donc au serveur la section qui le porte, et on
   * n'en réinjecte que le conteneur `[data-gift-line]` : re-rendre la section
   * entière écraserait la variante choisie et la quantité saisie.
   *
   * La section est résolue depuis le DOM plutôt que codée en dur, parce que le
   * formulaire vit dans une douzaine de sections différentes (PDP, cross-sell,
   * barre collante, cartes produit…). Une carte rendue côté client — l'îlot
   * Algolia — n'a pas de section porteuse : `closestSectionId` répond `null` et
   * rien n'est ajouté, l'îlot ayant sa propre lecture du panier.
   */
  withGiftLineTarget(targets) {
    if (!this.form?.querySelector(this.SELECTORS.giftLine)) return targets;
    const id = closestSectionId(this);
    if (!id) return targets;
    const existing = targets.find((target) => target.id === id);
    if (!existing) {
      return [...targets, { id, selector: [this.SELECTORS.giftLine] }];
    }
    if (!existing.selector) return targets;
    const selectors = Array.isArray(existing.selector) ? existing.selector : [existing.selector];
    if (selectors.includes(this.SELECTORS.giftLine)) return targets;
    return targets.map(
      (target) => target === existing ? { ...target, selector: [...selectors, this.SELECTORS.giftLine] } : target
    );
  }
  /**
   * Every listener is delegated on the host, not on `this.form`.
   *
   * `submit`, `change`, `click` and `focusin` all bubble, so binding on the
   * element itself works whether the children were parsed from HTML (they do
   * not exist yet at this point) or built by Preact. Binding on `this.form`
   * required the form to already exist, which is precisely what could not be
   * relied on — see `readDom()`.
   */
  connectedCallback() {
    if (this.hasConnected) return;
    this.hasConnected = true;
    setTimeout(() => {
      this.readDom();
      this.initNotifyMe();
      this.checkNotifyMeHash();
    }, 0);
    this.addEventListener("submit", async (e) => {
      this.readDom();
      if (!this.form) return;
      e.preventDefault();
      if (this.btnSubmit) this.btnSubmit.setAttribute("disabled", "true");
      if (this.btnSubmitAlreadyInfos)
        this.btnSubmitAlreadyInfos.setAttribute("disabled", "true");
      const loader = document.getElementById(this.SELECTORS.loaderId);
      if (loader) loader.setAttribute("aria-hidden", "false");
      await this.submitForm();
      if (loader) loader.setAttribute("aria-hidden", "true");
      if (this.btnSubmit) this.btnSubmit.removeAttribute("disabled");
      if (this.btnSubmitAlreadyInfos)
        this.btnSubmitAlreadyInfos.removeAttribute("disabled");
    });
    this.addEventListener("focusin", (e) => {
      this.readDom();
      if (this.action !== "update") return;
      const target = e.target;
      if (target.name?.startsWith("updates[")) this.captureQuantitySnapshot();
    });
    this.addEventListener("change", (e) => {
      const target = e.target;
      if (target.name?.includes("updates[")) {
        this.readDom();
        this.form?.requestSubmit();
      }
    });
    this.addEventListener("click", (e) => {
      const button = e.target.closest(
        this.SELECTORS.qtyButton
      );
      if (!button) return;
      this.readDom();
      if (!this.form) return;
      e.preventDefault();
      const step = parseInt(button.getAttribute("data-qty-step") || "0", 10);
      const inputs = Array.from(
        this.form.querySelectorAll(
          this.SELECTORS.updatesInput
        )
      );
      const stepped = inputs.filter(
        (el) => !el.matches(this.SELECTORS.qtyFixedInput)
      );
      const fixed = inputs.filter(
        (el) => el.matches(this.SELECTORS.qtyFixedInput)
      );
      let blockedByLimit = false;
      this.captureQuantitySnapshot();
      stepped.forEach((el) => {
        const currentVal = parseInt(el.value || "0", 10);
        const maxAttr = el.getAttribute("max");
        const maxQuantity = maxAttr ? parseInt(maxAttr, 10) : Number.NaN;
        const nextVal = currentVal + step;
        if (step > 0 && Number.isFinite(maxQuantity) && nextVal > maxQuantity) {
          blockedByLimit = true;
          return;
        }
        el.value = Math.max(0, nextVal).toString();
      });
      if (blockedByLimit) {
        this.quantitySnapshot = null;
        showCartLimitError();
        return;
      }
      const parentRemains = stepped.some(
        (el) => parseInt(el.value || "0", 10) > 0
      );
      fixed.forEach((el) => {
        el.value = parentRemains ? "1" : "0";
      });
      this.form.requestSubmit();
    });
  }
  /**
   * If the product is unavailable, the form renders an `<a data-notify-me-button>` link
   * instead of a submit button. This method polls for the third-party notify-me widget
   * and proxies clicks from our button to that widget.
   */
  initNotifyMe() {
    const notifyMeBtn = this.querySelector(this.SELECTORS.notifyMeButton);
    if (!notifyMeBtn) return;
    const href = notifyMeBtn.getAttribute("href") || "";
    if (href && !href.includes("#notify-me")) {
      notifyMeBtn.setAttribute("href", `${href}#notify-me`);
    }
    const bindNotifyWidget = (retries = 20, interval = 300) => {
      const widget = document.querySelector(
        this.SELECTORS.notifyWidget
      );
      if (widget) {
        widget.style.display = "none";
        notifyMeBtn.addEventListener("click", (event) => {
          event.preventDefault();
          widget.click();
        });
      } else if (retries > 0) {
        setTimeout(() => bindNotifyWidget(retries - 1, interval), interval);
      }
    };
    bindNotifyWidget();
  }
  /**
   * When landing on a product page with `#notify-me` in the URL (e.g. from a
   * collection card), auto-open the third-party notify-me widget.
   */
  checkNotifyMeHash() {
    if (window.location.hash !== "#notify-me") return;
    const autoOpenNotifyWidget = (retries = 20, interval = 300) => {
      const widget = document.querySelector(
        this.SELECTORS.notifyWidget
      );
      if (widget) {
        widget.click();
        history.replaceState(
          null,
          "",
          window.location.pathname + window.location.search
        );
      } else if (retries > 0) {
        setTimeout(() => autoOpenNotifyWidget(retries - 1, interval), interval);
      }
    };
    autoOpenNotifyWidget();
  }
  // Re-render la section `cart-samples` via l'Ajax Section Rendering API
  // (`?section_id=`) puis swap les blocs samples + packaging. Reload complet en
  // cas d'erreur.
  async renderSampleSection() {
    try {
      for (const section of this.sectionsRenderSamples) {
        await renderSection(section);
      }
    } catch (error) {
      console.error("[CartSamples] section render error:", error);
      window.location.reload();
    }
  }
  /**
   * Puts the cart page back in line with the cart after a failed mutation.
   *
   * The page can show a cart that has moved on — a line removed from another
   * tab, a page Safari brought back from its back/forward cache. Its inputs
   * then name line keys the cart no longer has, and `cart/update.js` refuses
   * the whole payload with a 422. Left on screen, those inputs were sent again
   * by every retry, which failed the same way. Same targets as a successful
   * mutation, fetched instead of read from the response.
   *
   * The recommendations are left alone: an Algolia round-trip and a carousel
   * back at its start, for no gain. A failed fetch keeps the page as it is —
   * no reload, unlike `renderSampleSection`: offline, that would trade the
   * cart for the browser's error page.
   */
  async resyncCartPage(targets) {
    try {
      await renderSections(targets);
      for (const section of this.sectionsRenderSamples) {
        await renderSection(section);
      }
    } catch (error) {
      console.error("[Cart] resync error:", error);
    }
  }
  /** Whether this submit takes its line out of the cart: the ✕, or `−` to 0. */
  isLineRemoval() {
    if (this.action === "remove") return true;
    return this.action === "update" && this.readAnnouncedQuantity() === 0;
  }
  /** Whether the cart page shows the line of this key. True without a key. */
  isLineShown(key) {
    if (!key) return true;
    return Boolean(
      document.querySelector(
        `${this.SELECTORS.cartItems} [data-line-key="${CSS.escape(key)}"]`
      )
    );
  }
  /**
   * Whether the refused request named a line the cart no longer has: the page
   * was behind the cart, and Shopify refused the whole payload for it — in the
   * shop's language, so the key tells, not the wording. Every line but the
   * samples shows its key, gift lines included, and no form of this element
   * names a sample. Read once the page is back in line with the cart: a failed
   * resync leaves every line shown.
   */
  isStale(error) {
    if (!this.isCart) return false;
    return error.lineKeys.some((key) => !this.isLineShown(key));
  }
  /**
   * Pose le nombre de coffrets voulu : on vide la ligne, puis on la repose.
   *
   * Aucun endpoint de l'Ajax Cart API ne sait retrancher sur une ligne
   * fusionnée. Elle rapporte toujours `quantity: 1`, donc tout ce qu'on lui
   * écrit est consommé comme facteur : depuis n coffrets on n'atteint que n×k
   * ou n+m, et `n−1` est hors du domaine. Vérifié levier par levier en
   * boutique, y compris les clés de `item_components`, que Liquid rend mais que
   * `updates` refuse en 422.
   *
   * Le formulaire porte les deux moitiés côte à côte — le `updates[…] = 0` qui
   * vide la ligne, et les `items[…]` qui la reposent à la cible. On les sépare
   * ici parce qu'elles ne partent pas au même endpoint.
   *
   * L'ordre n'est pas négociable : reposer avant de vider ferait fusionner le
   * nouvel envoi avec l'ancien, et doublerait le coffret. La contrepartie est
   * assumée — si le second appel échoue, le coffret est déjà sorti du panier —
   * et n'a pas d'alternative tant que la Cart Transform fixe la quantité à 1.
   *
   * Seule la réponse du réajout porte les sections : c'est l'état final. Rendre
   * celles de la suppression ferait clignoter un panier sans le coffret.
   */
  async setVirtualSetQuantity(formData, sectionsParam, targets) {
    const removals = new FormData();
    const additions = new FormData();
    for (const [key, value] of formData.entries()) {
      if (key.startsWith("updates[")) {
        removals.append(key, value);
      } else if (key.startsWith("items[")) {
        additions.append(key, value);
      }
    }
    if (![...additions.keys()].length) {
      throw new Error("[VirtualSet] aucun items[\u2026] \xE0 reposer");
    }
    additions.set("sections", sectionsParam);
    const order = this.readCartOrder();
    const root = window.Shopify?.routes?.root || "/";
    const headers = { "X-Requested-With": "XMLHttpRequest" };
    if ([...removals.keys()].length) {
      const removed = await fetch(`${root}cart/update.js`, {
        method: "POST",
        headers,
        body: removals
      });
      if (!removed.ok) {
        throw await this.readCartError(removed, namedLineKeys(removals));
      }
    }
    const added = await fetch(`${root}cart/add.js`, {
      method: "POST",
      headers,
      body: additions
    });
    if (!added.ok) throw await this.readCartError(added);
    const data = await added.json();
    hideCartLimitError();
    this.quantitySnapshot = null;
    const statusAnnouncement = this.buildCartMutationAnnouncement();
    await renderSections(targets, { sections: data.sections });
    this.restoreCartOrder(order);
    if (statusAnnouncement) {
      announceCartStatus(statusAnnouncement);
    }
    this.dispatchEvent(
      new CustomEvent("cart:add-success", {
        bubbles: true,
        detail: { data, action: this.action }
      })
    );
    if (this.isCart) {
      this.renderSampleSection();
      await this.rerenderCartRecommendSections();
    }
  }
  /** Les clés de ligne des cartes du panier, dans l'ordre où elles s'affichent. */
  readCartOrder() {
    return [
      ...document.querySelectorAll(this.SELECTORS.cartLine)
    ].flatMap((card) => card.dataset.lineKey ? [card.dataset.lineKey] : []);
  }
  /**
   * Remet les cartes du panier dans l'ordre relevé avant l'opération.
   *
   * Second filet, et non doublon de l'épinglage que fait `main-cart` : celui-ci
   * fixe la position de la FAMILLE — les coffrets en tête, l'emballage cadeau
   * en queue — mais laisse les coffrets entre eux dans l'ordre de `cart.items`.
   * Or descendre la quantité de l'un impose de vider sa ligne pour la reposer,
   * ce qui l'envoie en fin de tableau : avec deux coffrets au panier, agir sur
   * le premier le ferait passer derrière le second.
   *
   * Rejouer l'ordre relevé au clic répare ce cas-là, que l'épinglage ne couvre
   * pas. Réordonner et non figer : personne n'est assigné à un rang, et les
   * cartes absentes du relevé — une ligne apparue entre-temps — restent après,
   * dans leur ordre courant.
   *
   * Ne survit pas à un rechargement, où l'ordre de `cart.items` reprend la
   * main. Le stabiliser demanderait de mémoriser l'ordre côté serveur.
   *
   * La clé de ligne survit au vidage-réajout : vérifié en boutique, elle est
   * identique avant et après, ce qui est ce qui rend l'appariement possible.
   */
  restoreCartOrder(order) {
    if (order.length < 2) return;
    const cards = [
      ...document.querySelectorAll(this.SELECTORS.cartLine)
    ];
    const parent = cards[0]?.parentElement;
    if (!parent) return;
    const byKey = new Map(
      cards.filter((card) => card.parentElement === parent && card.dataset.lineKey).map((card) => [card.dataset.lineKey, card])
    );
    for (const key of order) {
      const card = byKey.get(key);
      if (card) {
        parent.appendChild(card);
        byKey.delete(key);
      }
    }
    for (const card of byKey.values()) parent.appendChild(card);
  }
  /**
   * Reads a failed Cart API answer. Shown by `submitForm`, once the cart page
   * is back in line with the cart: by then the error may have nothing left to
   * report. `lineKeys`: the cart lines the request named.
   */
  async readCartError(response, lineKeys = []) {
    const errorData = await response.json().catch(() => ({}));
    const text = errorData.description || errorData.message;
    return new CartRequestError(
      response.status,
      !text || TECHNICAL_ERROR_PATTERN.test(text),
      lineKeys,
      text || `Erreur ${response.status}`
    );
  }
  /** The banner of a failed Cart API answer — never Shopify's technical wording. */
  showCartError(error) {
    const rawMessage = error.message;
    if (isCartQuantityLimitError(error.status, rawMessage) || STOCK_LIMIT_PATTERN.test(rawMessage)) {
      showCartLimitError();
      return;
    }
    const fallback = error.technical || this.isStale(error) ? this.dataset.errorMessage || DEFAULT_CART_ERROR : rawMessage;
    showCartLimitError(this.errorMessages[rawMessage] || fallback);
  }
  captureQuantitySnapshot() {
    if (!this.form || this.action !== "update") return;
    this.quantitySnapshot = /* @__PURE__ */ new Map();
    this.form.querySelectorAll(this.SELECTORS.updatesInput).forEach((input) => {
      this.quantitySnapshot.set(input.name, input.value);
    });
  }
  restoreQuantitySnapshot() {
    if (!this.form || !this.quantitySnapshot) return;
    this.form.querySelectorAll(this.SELECTORS.updatesInput).forEach((input) => {
      const saved = this.quantitySnapshot.get(input.name);
      if (saved !== void 0) input.value = saved;
    });
    this.quantitySnapshot = null;
  }
  clearCartError() {
    hideCartLimitError();
  }
  /**
   * Builds a screen-reader message for a successful cart mutation, or null when
   * another surface (ATC popup) already announces the result.
   */
  buildCartMutationAnnouncement() {
    const title = this.dataset.productTitle?.trim() || "Item";
    if (this.action === "remove") {
      const template = this.dataset.itemRemovedTemplate || "__TITLE__ removed from bag";
      return fillCartStatusTemplate(template, { title });
    }
    if (this.action === "update" || this.action === "set_virtual_set" || this.action === "add_virtual_set" && this.isCart) {
      const quantity = this.readAnnouncedQuantity();
      if (quantity === 0) {
        const removedTemplate = this.dataset.itemRemovedTemplate || "__TITLE__ removed from bag";
        return fillCartStatusTemplate(removedTemplate, { title });
      }
      if (quantity !== null) {
        const template = this.dataset.quantityUpdatedTemplate || "__TITLE__ quantity updated to __QUANTITY__";
        return fillCartStatusTemplate(template, { title, quantity });
      }
    }
    if ((this.action === "add" || this.action === "add_virtual_set") && this.isCart) {
      const template = this.dataset.itemAddedTemplate || "__TITLE__ was added to bag";
      return fillCartStatusTemplate(template, { title });
    }
    return null;
  }
  /**
   * Resolves the quantity to announce after a cart stepper mutation.
   */
  readAnnouncedQuantity() {
    if (!this.form) return null;
    if (this.action === "set_virtual_set") {
      const quantityInput = this.form.querySelector(
        'input[name^="items["][name$="[quantity]"]'
      );
      if (!quantityInput) return null;
      const value2 = parseInt(quantityInput.value, 10);
      return Number.isFinite(value2) ? value2 : null;
    }
    if (this.action === "add_virtual_set") {
      const lineRoot = this.closest("[data-line-key]");
      const displayInput = lineRoot?.querySelector(
        `${this.SELECTORS.updatesInput}:not(${this.SELECTORS.qtyFixedInput})`
      );
      if (!displayInput) return null;
      const current = parseInt(displayInput.value, 10);
      if (!Number.isFinite(current)) return null;
      return current + 1;
    }
    const updatesInput = this.form.querySelector(
      `${this.SELECTORS.updatesInput}:not(${this.SELECTORS.qtyFixedInput})`
    );
    if (!updatesInput) return null;
    const value = parseInt(updatesInput.value, 10);
    return Number.isFinite(value) ? value : null;
  }
  fetchConfig(type = "json") {
    return {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/${type}`
      }
    };
  }
  // Outer swap des sections de recommandations : on collecte les ids des
  // wrappers `#shopify-section-…` autour de chaque `[data-cart-recommend-root]`
  // puis on remplace chaque wrapper par sa version fraîche.
  async rerenderCartRecommendSections() {
    const roots = document.querySelectorAll(this.SELECTORS.cartRecommendRoot);
    const sectionIds = collectSectionIds(roots);
    if (sectionIds.length === 0) return;
    await renderSections(sectionIds.map((id) => ({ id })));
  }
  disconnectedCallback() {
  }
};
if (!customElements.get("c-product-form")) {
  customElements.define("c-product-form", CProductForm);
  window.addEventListener("pageshow", (event) => {
    if (event.persisted && document.body.classList.contains("body--cart")) {
      window.location.reload();
    }
  });
  const [navigation] = performance.getEntriesByType(
    "navigation"
  );
  if (navigation?.type === "back_forward" && !(navigation.transferSize > 0) && document.body.classList.contains("body--cart")) {
    window.location.reload();
  }
}
initAlgoliaInsights();

// src/shared/algolia-page/page-base.ts
import {
  ALGOLIA_HIDDEN_GUARD_CONTEXT,
  ALGOLIA_HIDDEN_PRODUCTS_FILTER,
  CDN_ALGOLIASEARCH,
  CDN_INSTANTSEARCH,
  getRulePushes,
  giftedVersion,
  hasSearchPushHandles,
  ICON_BULLET,
  invalidateGiftedHandles,
  loadScript,
  minimumQueryLength,
  parseShortQueries,
  productAttributesToRetrieve,
  readStorefrontConfig,
  refreshGiftedHandles,
  renderStoryList,
  resolveGiftsForHits,
  resolveSearchPushes,
  SEARCH_DEBOUNCE_MS,
  SRI_ALGOLIASEARCH,
  SRI_INSTANTSEARCH
} from "@theme/algolia-shared";

// src/shared/card-product/align-product-card-zones.ts
var CARD_SELECTOR = ".card-product:not(.set-to-compose)";
var ZONE_CONFIGS = [
  { selector: ".card-product__meta", cssVar: "--card-meta-min-height" },
  { selector: ".card-product__price", cssVar: "--card-price-min-height" }
];
function groupIndicesByRow(tops) {
  const rows = [];
  for (const [index, top] of tops.entries()) {
    const row = rows.find((group) => {
      const first = group[0];
      return first !== void 0 && Math.abs((tops[first] ?? 0) - top) <= 1;
    });
    if (row) {
      row.push(index);
    } else {
      rows.push([index]);
    }
  }
  return rows;
}
function alignProductCardZones(root) {
  const cards = Array.from(root.querySelectorAll(CARD_SELECTOR));
  if (cards.length === 0) return;
  const zones = ZONE_CONFIGS.map(
    ({ selector }) => cards.map((card) => card.querySelector(selector))
  );
  for (const [zoneIndex, elements] of zones.entries()) {
    const cssVar = ZONE_CONFIGS[zoneIndex]?.cssVar;
    if (cssVar === void 0) continue;
    for (const el of elements) {
      el?.style.setProperty(cssVar, "0px");
    }
  }
  const tops = cards.map((card) => card.offsetTop);
  const heights = zones.map(
    (elements) => elements.map((el) => el?.scrollHeight ?? 0)
  );
  const rows = groupIndicesByRow(tops);
  for (const [zoneIndex, elements] of zones.entries()) {
    const cssVar = ZONE_CONFIGS[zoneIndex]?.cssVar;
    const zoneHeights = heights[zoneIndex];
    if (cssVar === void 0 || zoneHeights === void 0) continue;
    for (const row of rows) {
      let maxHeight = 0;
      for (const index of row) {
        maxHeight = Math.max(maxHeight, zoneHeights[index] ?? 0);
      }
      const value = `${String(maxHeight)}px`;
      for (const index of row) {
        elements[index]?.style.setProperty(cssVar, value);
      }
    }
  }
}

// src/shared/card-product/predecode-hover-visuals.ts
var HOVER_IMAGE_SELECTOR = ".card-product_image.is-hover-active figure:nth-child(even) img";
var NEAR_VIEWPORT_MARGIN = "400px";
var seen = /* @__PURE__ */ new WeakSet();
var observer = null;
function whenIdle(task) {
  if (typeof requestIdleCallback === "function") {
    requestIdleCallback(task, { timeout: 2e3 });
    return;
  }
  window.setTimeout(task, 200);
}
function decodeWhenLoaded(image) {
  const decode = () => whenIdle(() => void image.decode().catch(() => {
  }));
  if (image.complete && image.naturalWidth > 0) {
    decode();
    return;
  }
  image.addEventListener("load", decode, { once: true });
}
function nearViewportObserver() {
  if (observer) return observer;
  if (typeof IntersectionObserver !== "function") return null;
  observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer?.unobserve(entry.target);
        decodeWhenLoaded(entry.target);
      }
    },
    { rootMargin: NEAR_VIEWPORT_MARGIN }
  );
  return observer;
}
function predecodeHoverVisuals(root) {
  const images = root.querySelectorAll(HOVER_IMAGE_SELECTOR);
  if (images.length === 0) return;
  const io = nearViewportObserver();
  for (const image of images) {
    if (seen.has(image)) continue;
    seen.add(image);
    if (!io) {
      decodeWhenLoaded(image);
      continue;
    }
    io.observe(image);
  }
}

// src/shared/algolia-page/components/App.tsx
import { render } from "preact";

// src/shared/algolia-page/components/HitsGrid.tsx
import {
  orderRulePushSlots,
  placePush,
  ProductCard,
  PushCollectionCard,
  renderRulePush
} from "@theme/algolia-shared";
import { Fragment, jsx, jsxs } from "preact/jsx-runtime";
function pushColumnsStyle(push) {
  const columns = Number(push.columns);
  if (!Number.isInteger(columns) || columns <= 1) return void 0;
  return { "--push-columns": columns };
}
function PushCell({ push }) {
  return /* @__PURE__ */ jsx(
    "li",
    {
      style: pushColumnsStyle(push),
      dangerouslySetInnerHTML: { __html: renderRulePush(push) }
    }
  );
}
function CollectionPushLi({
  html,
  styleAttr
}) {
  return /* @__PURE__ */ jsx(
    "li",
    {
      ref: (el) => {
        if (!el) return;
        if (styleAttr) el.setAttribute("style", styleAttr);
        else el.removeAttribute("style");
      },
      dangerouslySetInnerHTML: { __html: html }
    }
  );
}
function CollectionPushCells({ html }) {
  if (typeof document === "undefined") return null;
  const host = document.createElement("div");
  host.innerHTML = html;
  const roots = Array.from(host.children);
  if (roots.length === 0) return null;
  return /* @__PURE__ */ jsx(Fragment, { children: roots.map((root, index) => /* @__PURE__ */ jsx(
    CollectionPushLi,
    {
      html: root.outerHTML,
      styleAttr: root.getAttribute("style") || ""
    },
    `collection-push-${index}`
  )) });
}
function PlacedPushCell({ push }) {
  const placement = placePush(push);
  const style = {
    "--push-row-mobile": placement.rowMobile,
    "--push-col-mobile": placement.colMobile,
    "--push-span-mobile": placement.spanMobile,
    "--push-row-desktop": placement.rowDesktop,
    "--push-col-desktop": placement.colDesktop,
    "--push-span-desktop": placement.spanDesktop,
    ...push.ratioMobile ? { "--push-ratio-mobile": push.ratioMobile } : {},
    ...push.ratioDesktop ? { "--push-ratio-desktop": push.ratioDesktop } : {}
  };
  return /* @__PURE__ */ jsx("li", { style, children: /* @__PURE__ */ jsx(PushCollectionCard, { push }) });
}
function NoResults({
  noResultsLabel,
  noResultsTemplate,
  query
}) {
  if (noResultsTemplate) {
    return /* @__PURE__ */ jsx("div", { dangerouslySetInnerHTML: { __html: noResultsTemplate } });
  }
  if (!query || !noResultsLabel) return null;
  return /* @__PURE__ */ jsx("div", { class: "no-result-search", children: /* @__PURE__ */ jsx("p", { class: "body-m-light", children: noResultsLabel.replace("TERMS", query) }) });
}
function HitsGrid({
  cardAssets,
  collectionPushes,
  gifts,
  hits,
  noResultsLabel,
  noResultsTemplate,
  placedPushes,
  pushes,
  query,
  stories
}) {
  if (hits.length === 0) {
    return /* @__PURE__ */ jsx(
      NoResults,
      {
        noResultsLabel,
        noResultsTemplate,
        query
      }
    );
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    orderRulePushSlots(pushes, hits.length).map((slot, cell) => {
      if (slot.kind === "push") {
        return /* @__PURE__ */ jsx(
          PushCell,
          {
            push: slot.push
          },
          `push-${slot.push.order}-${slot.push.title}`
        );
      }
      const hit = hits[slot.productIndex];
      return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(
        ProductCard,
        {
          assets: cardAssets,
          hit,
          rank: cell,
          resolvedGift: hit?.handle && gifts?.get(hit.handle) || null
        }
      ) }, `hit-${hit?.objectID ?? slot.productIndex}`);
    }),
    collectionPushes ? /* @__PURE__ */ jsx(CollectionPushCells, { html: collectionPushes }) : null,
    placedPushes.map((push) => /* @__PURE__ */ jsx(PlacedPushCell, { push }, `placed-${push.handle}`)),
    stories.map((html, index) => /* @__PURE__ */ jsx(CollectionPushCells, { html }, `story-${index}`))
  ] });
}

// src/shared/algolia-page/components/FilterChrome.tsx
import {
  ICON_CROSS_SVG
} from "@theme/algolia-shared";
import { Fragment as Fragment2, jsx as jsx2, jsxs as jsxs2 } from "preact/jsx-runtime";
var TRANSPARENT = { display: "contents" };
function Pagination({
  buildPageUrl,
  currentPage,
  pageLabel,
  totalPages
}) {
  if (totalPages <= 1) return null;
  return /* @__PURE__ */ jsx2(Fragment2, { children: Array.from({ length: totalPages }, (_, index) => index + 1).map(
    (page) => /* @__PURE__ */ jsxs2(
      "a",
      {
        href: buildPageUrl(page),
        "aria-current": page === currentPage ? "page" : void 0,
        children: [
          pageLabel,
          " ",
          page
        ]
      },
      page
    )
  ) });
}
function Stats({
  countTemplates,
  nbHits
}) {
  const template = nbHits === 1 ? countTemplates.one : countTemplates.other;
  return /* @__PURE__ */ jsx2("span", { class: "label-m-regular", children: template.replace("COUNT", String(nbHits)) });
}
function CurrentRefinements({
  groupLabel,
  onRemove,
  refinements
}) {
  if (refinements.length === 0) return null;
  return /* @__PURE__ */ jsx2("ul", { class: "filter-bar_list-tag", children: refinements.map((refinement) => /* @__PURE__ */ jsxs2(
    "li",
    {
      class: "tag_filter label-m-light",
      onClick: () => onRemove(refinement),
      children: [
        /* @__PURE__ */ jsx2("span", { children: formatFacetLabel(
          refinement.attribute,
          refinement.label,
          refinement.value
        ) || groupLabel(refinement.attribute) }),
        /* @__PURE__ */ jsx2(
          "span",
          {
            style: TRANSPARENT,
            dangerouslySetInnerHTML: { __html: ICON_CROSS_SVG }
          }
        )
      ]
    },
    `${refinement.attribute}:${refinement.value}`
  )) });
}
function ClearRefinements({
  label,
  onClear
}) {
  return /* @__PURE__ */ jsx2(
    "button",
    {
      class: "link fff v-secondary m-0",
      style: { margin: 0 },
      "data-ais-clear-all": true,
      onClick: onClear,
      children: /* @__PURE__ */ jsx2("span", { class: "cta--label", children: /* @__PURE__ */ jsx2("span", { class: "cta--label__text", children: label }) })
    }
  );
}
function SortOptions({
  currentRefinement,
  onRefine,
  options
}) {
  return /* @__PURE__ */ jsx2(Fragment2, { children: options.map((option) => {
    const id = `ais-sort-${option.value}`;
    return /* @__PURE__ */ jsxs2("div", { class: "input-radio", children: [
      /* @__PURE__ */ jsx2(
        "input",
        {
          type: "radio",
          id,
          name: "ais-sort-by",
          value: option.value,
          checked: option.value === currentRefinement,
          onChange: () => onRefine(option.value)
        }
      ),
      /* @__PURE__ */ jsx2("label", { for: id, children: option.label })
    ] }, option.value);
  }) });
}

// src/shared/algolia-page/components/FacetPanel.tsx
import {
  ICON_MINUS,
  ICON_PLUS
} from "@theme/algolia-shared";
import { jsx as jsx3, jsxs as jsxs3 } from "preact/jsx-runtime";
function Facet({
  actionLabels,
  attribute,
  canToggleShowMore,
  idPrefix,
  isShowingMore,
  items,
  label,
  onBulk,
  refine,
  toggleShowMore
}) {
  if (items.length === 0) return null;
  const hasChecked = items.some((item) => item.isRefined);
  return /* @__PURE__ */ jsxs3(
    "details",
    {
      "data-inputs-filter": true,
      "data-ais-facet": true,
      "data-ais-facet-attribute": attribute,
      children: [
        /* @__PURE__ */ jsxs3("summary", { children: [
          /* @__PURE__ */ jsx3("span", { children: label }),
          /* @__PURE__ */ jsxs3("div", { class: "container-plus-minus", children: [
            /* @__PURE__ */ jsx3("span", { class: "plus", dangerouslySetInnerHTML: { __html: ICON_PLUS } }),
            /* @__PURE__ */ jsx3(
              "span",
              {
                class: "minus",
                dangerouslySetInnerHTML: { __html: ICON_MINUS }
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ jsx3("div", { class: "ais-facet-action", children: /* @__PURE__ */ jsx3(
          "button",
          {
            type: "button",
            class: "link v-secondary m-0",
            "data-ais-facet-toggle": true,
            "data-has-checked-input": String(hasChecked),
            onClick: () => onBulk(
              attribute,
              items.map((item) => item.value),
              !hasChecked
            ),
            children: /* @__PURE__ */ jsx3("span", { class: "cta--label", children: /* @__PURE__ */ jsx3("span", { class: "cta--label__text", "data-ais-facet-toggle-label": true, children: hasChecked ? actionLabels.deselect : actionLabels.select }) })
          }
        ) }),
        /* @__PURE__ */ jsxs3("div", { class: "ais-facet-container", children: [
          /* @__PURE__ */ jsx3("ul", { class: "ais-rl-list", children: items.map((item) => {
            const id = `${idPrefix}-${item.value.replace(/[^a-z0-9]/gi, "-")}`;
            return /* @__PURE__ */ jsxs3("li", { class: "input-checkbox", children: [
              /* @__PURE__ */ jsx3(
                "input",
                {
                  type: "checkbox",
                  id,
                  value: item.value,
                  checked: item.isRefined,
                  onChange: () => refine(item.value)
                }
              ),
              /* @__PURE__ */ jsxs3("label", { for: id, children: [
                item.label,
                item.count > 0 ? /* @__PURE__ */ jsx3("span", { class: "filter_count-product", children: item.count }) : null
              ] })
            ] }, item.value);
          }) }),
          canToggleShowMore ? /* @__PURE__ */ jsx3(
            "button",
            {
              type: "button",
              class: "link v-secondary m-0 ais-show-more",
              onClick: toggleShowMore,
              children: /* @__PURE__ */ jsx3("span", { class: "cta--label", children: /* @__PURE__ */ jsx3("span", { class: "cta--label__text", children: isShowingMore ? actionLabels.showLess : actionLabels.showMore }) })
            }
          ) : null
        ] })
      ]
    }
  );
}

// src/shared/algolia-page/components/App.tsx
import { jsx as jsx4 } from "preact/jsx-runtime";
var owned = /* @__PURE__ */ new WeakSet();
function renderInto(container, children) {
  if (!(container instanceof HTMLElement)) return;
  if (!owned.has(container)) {
    owned.add(container);
    container.replaceChildren();
  }
  render(children, container);
}
function renderHitsGrid(container, props) {
  renderInto(container, /* @__PURE__ */ jsx4(HitsGrid, { ...props }));
}
function renderStats(container, nbHits, countTemplates) {
  renderInto(
    container,
    /* @__PURE__ */ jsx4(Stats, { countTemplates, nbHits })
  );
}
function renderCurrentRefinements(container, refinements, onRemove, groupLabel) {
  renderInto(
    container,
    /* @__PURE__ */ jsx4(
      CurrentRefinements,
      {
        refinements,
        onRemove,
        groupLabel
      }
    )
  );
}
function renderClearRefinements(container, label, onClear) {
  renderInto(
    container,
    onClear ? /* @__PURE__ */ jsx4(ClearRefinements, { label, onClear }) : null
  );
}
function renderPagination(container, props) {
  renderInto(container, /* @__PURE__ */ jsx4(Pagination, { ...props }));
}
function renderSortOptions(container, props) {
  renderInto(container, /* @__PURE__ */ jsx4(SortOptions, { ...props }));
}
function renderFacet(container, props) {
  renderInto(container, /* @__PURE__ */ jsx4(Facet, { ...props }));
}

// src/shared/algolia-page/routing.ts
var ROUTING_KEYS = /* @__PURE__ */ new Set(["q", "page", "sort_by"]);
function isRoutingKey(key) {
  return ROUTING_KEYS.has(key) || key.startsWith("filter.");
}
function decodeKey(rawKey) {
  try {
    return decodeURIComponent(rawKey.replace(/\+/g, " "));
  } catch {
    return rawKey;
  }
}
function foreignQueryString(search) {
  return search.replace(/^\?/, "").split("&").filter((pair) => pair && !isRoutingKey(decodeKey(pair.split("=")[0]))).join("&");
}
var METAOBJECT_GID_PREFIX = "gid://shopify/Metaobject/";
function isMetaobjectFacet(attribute) {
  return ALGOLIA_METAOBJECT_FACET_ATTRIBUTES.includes(attribute);
}
function encodeFacetValue(attribute, value) {
  if (!isMetaobjectFacet(attribute)) return value;
  return value.startsWith(METAOBJECT_GID_PREFIX) ? value.slice(METAOBJECT_GID_PREFIX.length) : value;
}
function decodeFacetValue(attribute, value) {
  if (!isMetaobjectFacet(attribute)) return value;
  return /^\d+$/.test(value) ? `${METAOBJECT_GID_PREFIX}${value}` : value;
}
function buildRouting(indexName, instantsearch, options = {}) {
  const { defaultSortBy = "", enableSort = true } = options;
  return {
    router: instantsearch.routers.history({
      createURL({
        qsModule,
        routeState,
        location
      }) {
        const { origin, pathname, search, hash } = location;
        const queryString = [
          qsModule.stringify(routeState),
          foreignQueryString(search)
        ].filter(Boolean).join("&");
        return queryString ? `${origin}${pathname}?${queryString}${hash}` : `${origin}${pathname}${hash}`;
      },
      parseURL({
        qsModule,
        location
      }) {
        return qsModule.parse(location.search.slice(1));
      }
    }),
    stateMapping: {
      stateToRoute: (uiState) => {
        const indexState = uiState[indexName] || {};
        const route = {};
        if (indexState.query) route.q = indexState.query;
        if (indexState.page && indexState.page > 1) {
          route.page = String(indexState.page);
        }
        if (indexState.refinementList) {
          Object.entries(indexState.refinementList).forEach(
            ([attribute, values]) => {
              if (!values.length) return;
              route[`filter.${attribute}`] = values.map((value) => encodeFacetValue(attribute, value)).join("|");
            }
          );
        }
        if (enableSort && indexState.sortBy && indexState.sortBy !== defaultSortBy) {
          route.sort_by = indexState.sortBy;
        }
        return route;
      },
      routeToState: (routeState) => {
        const refinementList = {};
        Object.entries(routeState).forEach(([key, value]) => {
          if (!key.startsWith("filter.")) return;
          const attribute = key.slice("filter.".length);
          refinementList[attribute] = String(value).split("|").map((entry) => decodeFacetValue(attribute, entry));
        });
        return {
          [indexName]: {
            query: String(routeState.q || ""),
            ...Object.keys(refinementList).length && { refinementList },
            ...enableSort && routeState.sort_by ? { sortBy: routeState.sort_by } : {},
            ...enableSort && !routeState.sort_by && defaultSortBy ? { sortBy: defaultSortBy } : {}
          }
        };
      }
    }
  };
}

// src/shared/algolia-page/search-client.ts
function withoutAnalyticsForEmptyQuery(request) {
  const query = String(request.params?.query ?? "").trim();
  if (query) return request;
  return {
    ...request,
    params: {
      ...request.params,
      analytics: false
    }
  };
}
function withoutEmptyQueryAnalytics(searchClient) {
  const client = searchClient;
  if (typeof client.search !== "function") return searchClient;
  return {
    ...client,
    search(requests) {
      return client.search(requests.map(withoutAnalyticsForEmptyQuery));
    }
  };
}

// src/shared/algolia-page/page-base.ts
function readClearLabel(clearEl) {
  return clearEl instanceof HTMLElement ? clearEl.dataset.clearLabel || "Deselect all" : "Deselect all";
}
var AlgoliaPageBase = class extends HTMLElement {
  constructor() {
    super(...arguments);
    this.search = null;
    /** The client InstantSearch searches with, kept for out-of-band lookups. */
    this.searchClient = null;
    this.config = null;
    /** Read once on connect — the dataset does not change between renders. */
    this.labels = {
      noResults: "",
      page: "Page",
      productCountOne: "COUNT product",
      productCountOther: "COUNT products"
    };
    /** Every hit painted so far for the current query, across pages. */
    this.renderedHits = [];
    /** Pushes resolved through the Storefront API, folded into the render. */
    this.resolvedPushes = [];
    /**
     * Tuiles `push_collection` résolues par handle. Séparées des précédentes
     * parce qu'elles ne s'intercalent pas : elles se placent par CSS, comme
     * celles que Liquid rend sur la PLP.
     */
    this.resolvedPlacedPushes = [];
    /** Modules `block_story_list` résolus par handle. Placés comme les précédents. */
    this.resolvedStories = [];
    /** Lus une fois : icônes et libellés du module story ne changent pas. */
    this.storyAssetsCache = null;
    /** Markup Liquid des pushes de collection, lu une fois. Voir readCollectionPushTemplate. */
    this.pushTemplateCache = null;
    /** Gifts resolved through the Section Rendering API, keyed by parent handle. */
    this.resolvedGifts = null;
    this.giftToken = 0;
    /** Dernière grille rendue, à re-rendre quand le panier change sous elle. */
    this.hitsGrid = null;
    this.cartGiftToken = 0;
    /** Numéro d'état du panier avec lequel la grille a été peinte. */
    this.renderedGiftVersion = -1;
    this.gridState = null;
    this.pushToken = 0;
    this.zoneAlignObserver = null;
    this.hitsGridForAlign = null;
    this.isAligningZones = false;
    /** Dernière largeur de grille alignée, pour ignorer les resizes en hauteur. */
    this.lastAlignedWidth = 0;
    this.fontsAlignBound = false;
    this.nightStripObserver = null;
    /**
     * Aborted on disconnect. Every listener this element puts on a node it does
     * not own — `document`, the hero form/input, the filter dialog — is registered
     * with this signal, because those nodes outlive the element and would
     * otherwise keep the old handlers alive. The theme editor reconnects the
     * section on each edit, so without this each edit added one more handler.
     */
    this.controller = null;
  }
  async connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.labels = this.readPageLabels();
    this.setNoResultsMessageVisible(false);
    await this.loadDependencies();
    await this.waitForDocumentReady();
    if (signal.aborted) return;
    const config = this.readConfig();
    if (!config) return;
    this.config = config;
    const instantsearch = window.instantsearch;
    const liteClient = window["algoliasearch/lite"]?.liteClient;
    if (!instantsearch || !liteClient) return;
    const heroInput = document.querySelector(
      '.hero-search input[name="q"]'
    );
    const initialQuery = new URLSearchParams(window.location.search).get("q") || "";
    if (heroInput) heroInput.value = initialQuery;
    this.updateQueryUi(initialQuery);
    this.searchClient = withoutEmptyQueryAnalytics(
      liteClient(config.appId, config.apiKey)
    );
    this.search = instantsearch({
      indexName: config.indexName,
      searchClient: this.searchClient,
      routing: buildRouting(config.indexName, instantsearch, {
        defaultSortBy: config.defaultSortBy
      }),
      future: { preserveSharedStateOnUnmount: true },
      // The theme emits no Algolia Insights event. `false` also keeps
      // InstantSearch's own automatic view events off — left on, the widget
      // would mint its own anonymous user token and start reporting.
      insights: false
    });
    const widgets = this.buildWidgets(config, instantsearch, heroInput);
    this.search.addWidgets(widgets);
    this.search.start();
    this.setupDialog();
    this.setupSearchStateHandlers();
    document.addEventListener(
      "cart:add-success",
      () => {
        invalidateGiftedHandles();
        const grid = this.hitsGrid;
        if (grid) void this.hydrateCartGifts(grid);
      },
      { signal }
    );
  }
  disconnectedCallback() {
    this.zoneAlignObserver?.disconnect();
    this.zoneAlignObserver = null;
    this.nightStripObserver?.disconnect();
    this.nightStripObserver = null;
    this.hitsGridForAlign = null;
    this.lastAlignedWidth = 0;
    this.hitsGrid = null;
    this.controller?.abort();
    this.controller = null;
    this.search?.dispose();
    this.search = null;
    this.searchClient = null;
  }
  /**
   * Analytics tag(s) attached to every search request of this page, so events
   * can be segmented by page type in Algolia Analytics. Overridden by the
   * collection page to distinguish category browsing from site search.
   */
  searchAnalyticsTags() {
    return ["search-page"];
  }
  /**
   * Rule contexts attached to every search request, so Algolia Query Rules can
   * target this surface (e.g. search-specific merchandising pushes). Must match
   * the `context` set on the rule — see docs/pushes-algolia.md. Overridden by
   * the collection page. Do not also add a `queryRuleContext` widget: both write
   * the same parameter and would double it.
   */
  searchRuleContexts() {
    return ["search"];
  }
  updateQueryUi(_query) {
  }
  /**
   * Hook invoked on every new first page of results, before it is painted.
   * Returns `true` when the page is navigating away — the grid is then left
   * unpainted, so the skeleton stays on screen until the navigation instead of
   * flashing products. No-op in the base class: the search page overrides it to
   * follow Query Rule redirects, the collection page must never redirect.
   */
  followResultsRedirect(_results) {
    return false;
  }
  /**
   * Hook invoked when the hero search form is submitted. The query is already
   * refined live while typing, so the base class only keeps the browser from
   * reloading; the search page overrides it to follow a redirect on Enter.
   */
  onHeroSubmit(_query) {
  }
  mergeSortItems(...sortValues) {
    const seen2 = /* @__PURE__ */ new Set();
    return sortValues.flatMap((value) => parsePairs(value)).filter((item) => {
      if (!item.value || seen2.has(item.value)) return false;
      seen2.add(item.value);
      return true;
    });
  }
  defaultSortBy(value, sortItems) {
    const defaultSortValue = parsePairs(value)[0]?.value ?? value.trim();
    if (!defaultSortValue) return "";
    if (!sortItems.some((item) => item.value === defaultSortValue)) return "";
    return defaultSortValue;
  }
  withDefaultSortItem(sortItems, defaultSortValue) {
    const defaultSortItem = parsePairs(defaultSortValue)[0];
    if (!defaultSortItem) return sortItems;
    return [
      defaultSortItem,
      ...sortItems.filter((item) => item.value !== defaultSortItem.value)
    ];
  }
  async loadDependencies() {
    await Promise.all([
      loadScript(CDN_ALGOLIASEARCH, SRI_ALGOLIASEARCH),
      loadScript(CDN_INSTANTSEARCH, SRI_INSTANTSEARCH)
    ]);
  }
  waitForDocumentReady() {
    if (document.readyState !== "loading") return Promise.resolve();
    return new Promise((resolve) => {
      document.addEventListener("DOMContentLoaded", () => resolve(), {
        once: true
      });
    });
  }
  readPageLabels() {
    return {
      noResults: this.dataset.noResultsLabel || "",
      page: this.dataset.pageLabel || "Page",
      productCountOne: this.dataset.productCountOne || "COUNT product",
      productCountOther: this.dataset.productCountOther || "COUNT products"
    };
  }
  readProductCardAssets() {
    return {
      alertIcon: this.querySelector(
        'template[data-algolia-icon="alert"]'
      )?.innerHTML.trim() ?? "",
      notifyMeLabel: this.dataset.notifyMeLabel || "",
      quickBuyIcon: this.querySelector(
        'template[data-algolia-icon="quick-buy"]'
      )?.innerHTML.trim() ?? "",
      quickBuyLabel: this.dataset.quickBuyLabel || "",
      setToComposeLabel: this.dataset.setToComposeLabel || "",
      cardActionAriaLabel: this.dataset.cardActionAriaLabel || "",
      contenanceLabel: this.dataset.contenanceLabel || "Contenance",
      modelsLabelOne: this.dataset.modelsLabelOne || "+{{ count }} model",
      modelsLabelOther: this.dataset.modelsLabelOther || "+{{ count }} models",
      plpFirstVisual: this.dataset.plpFirstVisual === "true"
    };
  }
  /**
   * Icônes et libellés du module story, tous rendus par Liquid.
   *
   * Les icônes voyagent dans des `<template>` inertes comme celles de la carte
   * produit : ce sont des tracés dessinés à la main, plusieurs kilo-octets à
   * eux tous, et les recopier en JS les ferait exister en deux exemplaires.
   * Les libellés voyagent en `data-*`, le rendu tournant après le paint.
   */
  readStoryAssets() {
    const icon = (name) => this.querySelector(
      `template[data-algolia-icon="${name}"]`
    )?.innerHTML.trim() ?? "";
    this.storyAssetsCache ?? (this.storyAssetsCache = {
      chevronNextIcon: icon("story-next"),
      chevronPrevIcon: icon("story-prev"),
      labelMute: this.dataset.storyLabelMute || "",
      labelNext: this.dataset.storyLabelNext || "",
      labelPause: this.dataset.storyLabelPause || "",
      labelPlay: this.dataset.storyLabelPlay || "",
      labelPositionTemplate: this.dataset.storyLabelPosition || "",
      labelPrev: this.dataset.storyLabelPrev || "",
      labelReplay: this.dataset.storyLabelReplay || "",
      labelStory: this.dataset.storyLabel || "",
      labelUnmute: this.dataset.storyLabelUnmute || "",
      mutedIcon: icon("story-muted"),
      pauseIcon: icon("story-pause"),
      playIcon: icon("story-play"),
      restartIcon: icon("story-restart"),
      unmutedIcon: icon("story-unmuted")
    });
    return this.storyAssetsCache;
  }
  buildWidgets(config, instantsearch, heroInput) {
    const { connectors, widgets } = instantsearch;
    const facetAttributes = this.requestedFacetAttributes(config.facetPairs);
    const filters = this.searchFilters(config.collectionFilter);
    const widgetList = [
      widgets.configure({
        facets: facetAttributes,
        ...filters ? { filters } : {},
        analyticsTags: this.searchAnalyticsTags(),
        ruleContexts: this.ruleContexts(),
        attributesToHighlight: [],
        attributesToRetrieve: productAttributesToRetrieve(),
        hitsPerPage: ALGOLIA_HITS_PER_PAGE,
        ignorePlurals: true,
        maxValuesPerFacet: ALGOLIA_MAX_VALUES_PER_FACET,
        removeWordsIfNoResults: "allOptional",
        typoTolerance: true
      })
    ];
    this.addSearchBoxWidget(widgetList, connectors, heroInput);
    this.addStatsWidget(widgetList, connectors);
    this.addCurrentRefinementsWidget(widgetList, connectors);
    this.addSortWidget(widgetList, connectors, config.sortItems);
    this.addFacetWidgets(
      widgetList,
      widgets,
      config.facetPairs,
      connectors,
      config.hiddenFacets
    );
    this.addInfiniteHitsWidget(widgetList, instantsearch, config.indexName);
    return widgetList;
  }
  /**
   * Exception assumée : cette collection affiche aussi les produits masqués.
   * Pilotée par le métafield de collection `custom.algolia_show_hidden`, rendu en
   * data-attribute par la section. Absent de la page recherche, qui masque donc
   * toujours.
   */
  showsHiddenProducts() {
    return this.dataset.algoliaShowHidden === "true";
  }
  /**
   * Les deux gardes du masquage sont relâchés ensemble, et c'est le point à ne pas
   * casser : retirer le filtre sans retirer le contexte laisserait la Query Rule
   * filtrer côté serveur, et l'inverse laisserait le thème le faire tout seul.
   * Dans les deux cas l'exception ne produirait rien de visible.
   */
  ruleContexts() {
    const contexts = this.searchRuleContexts();
    return this.showsHiddenProducts() ? contexts : [...contexts, ALGOLIA_HIDDEN_GUARD_CONTEXT];
  }
  /**
   * Filtre de base de la page, avant les raffinements de facettes qu'InstantSearch
   * ajoute par-dessus : les produits masqués sont exclus partout, la page
   * collection y ajoute son propre filtre de collection.
   *
   * Chaque clause est parenthésée : `NOT` ne porte que sur la clause qui le suit,
   * donc `NOT a:1 AND b:"c"` reste correct mais devient illisible dès qu'une
   * clause s'ajoute — les parenthèses rendent la portée explicite.
   */
  searchFilters(collectionFilter) {
    const collection = collectionFilter?.trim();
    return [
      ...this.showsHiddenProducts() ? [] : [ALGOLIA_HIDDEN_PRODUCTS_FILTER],
      ...collection ? [collection] : []
    ].map((clause) => `(${clause})`).join(" AND ");
  }
  facetAttributes(facetPairs) {
    return facetPairs.map(({ value }) => value).filter(Boolean);
  }
  requestedFacetAttributes(facetPairs) {
    const facetAttributes = this.facetAttributes(facetPairs);
    return facetAttributes.length ? facetAttributes : ["*"];
  }
  facetGroupLabels() {
    if (this.facetLocaleLabels) return this.facetLocaleLabels;
    const refinementsEl = document.querySelector(
      "[data-ais-refinements]"
    );
    try {
      this.facetLocaleLabels = JSON.parse(
        refinementsEl?.dataset.facetLabels || "{}"
      );
    } catch {
      this.facetLocaleLabels = {};
    }
    return this.facetLocaleLabels;
  }
  /**
   * Libellé d'un groupe de facettes.
   *
   * La clé COMPLÈTE est essayée en premier, et c'est structurel : le dernier
   * segment de `meta.custom.capacity._id`, `…format._id` et
   * `…product_tags._id` vaut `_id` pour les trois. Le repli par segment ne
   * distinguerait rien — il ne survit que pour les clés historiques
   * (`price_range`, `tags`, `collections`, `contenance`).
   *
   * Une clé de locale absente donne « Translation missing: xx.… », chaîne
   * *truthy* qui partirait telle quelle en titre de groupe. C'est déjà arrivé
   * en production sur ce projet : on la traite comme une absence.
   */
  facetGroupLabel(attribute, labelMap = {}) {
    const localeLabels = this.facetGroupLabels();
    const localeKey = attribute.split(".").pop() ?? attribute;
    const resolved = [
      localeLabels[attribute],
      localeLabels[localeKey],
      labelMap[attribute]
    ].find((value) => value && !value.startsWith("Translation missing"));
    return resolved || labelFromAttr(attribute);
  }
  addSearchBoxWidget(widgetList, connectors, heroInput) {
    const heroForm = document.querySelector(".hero-search form");
    heroForm?.addEventListener(
      "submit",
      (event) => {
        event.preventDefault();
        this.onHeroSubmit(heroInput?.value ?? "");
      },
      { signal: this.controller?.signal }
    );
    const shortQueries = parseShortQueries(this.dataset.algoliaShortQueries);
    let refine = null;
    let debounce = null;
    const customSearchBox = connectors.connectSearchBox(
      ({
        query,
        refine: nextRefine
      }) => {
        if (heroInput && document.activeElement !== heroInput) {
          heroInput.value = query;
        }
        this.updateQueryUi(query);
        refine = nextRefine;
      }
    );
    widgetList.push(
      customSearchBox({
        queryHook: (query, search) => {
          if (debounce) clearTimeout(debounce);
          const nextQuery = query.trim();
          const minLength = minimumQueryLength(nextQuery, shortQueries);
          if (nextQuery.length > 0 && nextQuery.length < minLength) return;
          debounce = setTimeout(() => search(nextQuery), SEARCH_DEBOUNCE_MS);
        }
      })
    );
    heroInput?.addEventListener(
      "input",
      () => {
        this.updateQueryUi(heroInput.value);
        this.setNoResultsMessageVisible(false);
        refine?.(heroInput.value);
      },
      { signal: this.controller?.signal }
    );
  }
  addStatsWidget(widgetList, connectors) {
    const statsEl = document.querySelector("[data-ais-stats]");
    const applyLabelEl = document.querySelector("[data-ais-apply-label]");
    const applyBtn = document.querySelector(
      "[data-ais-dialog-close]"
    );
    if (!statsEl) return;
    const customStats = connectors.connectStats(
      ({ nbHits }) => {
        renderStats(statsEl, nbHits, {
          one: this.labels.productCountOne,
          other: this.labels.productCountOther
        });
        if (!applyLabelEl || !applyBtn) return;
        const template = nbHits === 1 ? applyBtn.dataset.applyOne : applyBtn.dataset.applyOther;
        applyLabelEl.textContent = template?.replace("{count}", String(nbHits)) ?? `Apply (${nbHits})`;
      }
    );
    widgetList.push(customStats({}));
  }
  addCurrentRefinementsWidget(widgetList, connectors) {
    const currentRefEl = document.querySelector(
      "[data-ais-current-refinements]"
    );
    const clearEl = document.querySelector("[data-ais-clear]");
    const resetEl = document.querySelector("[data-ais-reset-all]");
    if (!currentRefEl) return;
    const groupLabel = (attribute) => attribute ? this.facetGroupLabel(attribute) : "";
    const customCurrentRefinements = connectors.connectCurrentRefinements(
      ({
        items,
        refine
      }) => {
        const allRefinements = items.flatMap((item) => item.refinements);
        const clearAll = () => items.forEach(
          (item) => item.refinements.forEach((refinement) => refine(refinement))
        );
        if (allRefinements.length === 0) {
          renderCurrentRefinements(currentRefEl, [], refine, groupLabel);
          renderClearRefinements(clearEl, "", null);
          if (resetEl) resetEl.hidden = true;
          return;
        }
        renderCurrentRefinements(
          currentRefEl,
          allRefinements,
          refine,
          groupLabel
        );
        renderClearRefinements(clearEl, readClearLabel(clearEl), clearAll);
        this.renderResetRefinements(resetEl, items, refine);
      }
    );
    widgetList.push(customCurrentRefinements({ container: currentRefEl }));
  }
  renderResetRefinements(resetEl, items, refine) {
    if (!resetEl) return;
    if (resetEl.hidden) resetEl.hidden = false;
    resetEl.onclick = () => {
      items.forEach(
        (item) => item.refinements.forEach((refinement) => refine(refinement))
      );
    };
  }
  addSortWidget(widgetList, connectors, sortItems) {
    const sortEl = document.querySelector("[data-ais-sort]");
    if (!sortEl || sortItems.length === 0) {
      document.querySelector("[data-ais-sort-fieldset]")?.remove();
      return;
    }
    const customSortBy = connectors.connectSortBy(
      ({
        options,
        currentRefinement,
        refine
      }) => {
        renderSortOptions(sortEl, {
          currentRefinement,
          onRefine: refine,
          options
        });
      }
    );
    widgetList.push(customSortBy({ container: sortEl, items: sortItems }));
  }
  addFacetWidgets(widgetList, widgets, facetPairs, connectors, hiddenFacets) {
    const refinementsEl = document.querySelector("[data-ais-refinements]");
    if (!refinementsEl) return;
    const facetActionLabels = this.readFacetActionLabels(refinementsEl);
    const capacityOrder = parseCapacityOrder(this.dataset.algoliaCapacityOrder);
    const labelMap = Object.fromEntries(
      facetPairs.map(({ value, label }) => [value, label])
    );
    widgetList.push(
      widgets.dynamicWidgets({
        container: refinementsEl,
        facets: this.requestedFacetAttributes(facetPairs),
        // Masquage piloté par les réglages de section (`show_facet_*`) : les
        // attributs restent demandés à Algolia, on retire seulement ceux à
        // masquer de la liste rendue.
        transformItems: (attributes) => attributes.filter(
          (attribute) => !isHiddenFacet(attribute, hiddenFacets)
        ),
        fallbackWidget: ({
          attribute,
          container
        }) => {
          const label = this.facetGroupLabel(attribute, labelMap);
          const customRefinementList = connectors.connectRefinementList(
            (options) => {
              renderFacet(container, {
                actionLabels: facetActionLabels,
                attribute,
                canToggleShowMore: options.canToggleShowMore,
                idPrefix: `ais-facet-${attribute.replace(/[^a-z0-9]/gi, "-")}`,
                isShowingMore: options.isShowingMore,
                items: options.items,
                label,
                onBulk: (facetAttribute, values, select) => this.applyBulkFacetSelection(facetAttribute, values, select),
                refine: options.refine,
                toggleShowMore: options.toggleShowMore
              });
            }
          );
          return customRefinementList({
            attribute,
            limit: 10,
            showMore: true,
            showMoreLimit: ALGOLIA_MAX_VALUES_PER_FACET,
            sortBy: facetSortBy(attribute),
            transformItems: (items) => formatFacetItems(attribute, items, capacityOrder)
          });
        },
        widgets: []
      })
    );
  }
  readFacetActionLabels(refinementsEl) {
    if (!(refinementsEl instanceof HTMLElement)) {
      return {
        deselect: "Deselect all",
        select: "Select all",
        showLess: "See less",
        showMore: "See all"
      };
    }
    return {
      deselect: refinementsEl.dataset.deselectLabel || "Deselect all",
      select: refinementsEl.dataset.selectLabel || "Select all",
      showLess: refinementsEl.dataset.showLessLabel || "See less",
      showMore: refinementsEl.dataset.showMoreLabel || "See all"
    };
  }
  addInfiniteHitsWidget(widgetList, instantsearch, indexName) {
    const hitsEl = this.querySelector("[data-ais-hits]");
    if (!hitsEl) return;
    const { connectors } = instantsearch;
    const cardAssets = this.readProductCardAssets();
    const noResultsTemplate = this.readNoResultsTemplate();
    let showMore = null;
    let renderedCount = 0;
    let hasRenderedFirstPage = false;
    let isLoadingMore = false;
    let isLastRenderedPage = false;
    let renderedResults = null;
    let pendingInitialPageLoads = this.readInitialPageTarget() - 1;
    const loadNextPage = () => {
      if (!hasRenderedFirstPage || isLoadingMore || isLastRenderedPage) return;
      isLoadingMore = true;
      showMore?.();
    };
    const customInfiniteHits = connectors.connectInfiniteHits(
      (options, isFirstRender) => {
        showMore = options.showMore;
        isLastRenderedPage = options.isLastPage;
        if (isFirstRender) {
          this.renderHitsSkeleton(hitsEl, loadNextPage);
          return;
        }
        const grid = hitsEl.querySelector("[data-ais-grid]");
        if (!grid) return;
        const page = options.results?.page ?? 0;
        const isNewResults = options.results !== renderedResults;
        renderedResults = options.results ?? null;
        if (isNewResults && page === 0) {
          if (this.followResultsRedirect(options.results)) return;
          renderedCount = this.renderFirstHitsPage(
            grid,
            options,
            cardAssets,
            noResultsTemplate,
            indexName
          );
          hasRenderedFirstPage = true;
          if (options.results) {
            this.updateEmptyState(
              options.results.query ?? "",
              options.results.nbHits ?? options.results.hits.length ?? 0
            );
          }
        } else if (isNewResults && page > 0) {
          isLoadingMore = false;
          renderedCount = this.appendHitsPage(
            grid,
            options.currentPageHits ?? options.hits.slice(renderedCount),
            renderedCount
          );
        }
        this.updateHitsFooter(hitsEl, options, renderedCount);
        this.updatePaginationHeadTags(
          options.results?.page ?? 0,
          options.results?.nbPages ?? 0
        );
        if (isNewResults && pendingInitialPageLoads > 0 && renderedCount > 0 && !options.isLastPage) {
          pendingInitialPageLoads -= 1;
          loadNextPage();
        }
      }
    );
    widgetList.push(customInfiniteHits({}));
  }
  /**
   * The static shell, and the boundary between the imperative host and the
   * Preact islands: it creates the containers (`[data-ais-grid]`,
   * `[data-ais-pagination]`) that Preact then takes over and owns.
   *
   * The `innerHTML` here stays on purpose — this runs once, on the widget's
   * first render, and it is what gives the islands their mount points. Rewriting
   * it later would detach containers Preact still holds in its takeover set,
   * leaving it rendering into orphaned nodes. Guarded upstream by
   * `isFirstRender`.
   */
  renderHitsSkeleton(hitsEl, onLoadMore) {
    const loadMoreLabel = this.dataset.productLoadMoreLabel || "Display more";
    hitsEl.innerHTML = `
      <ul data-ais-grid></ul>
      <nav data-ais-pagination class='sr-only' aria-label='Pagination'></nav>
      <div data-rerender-more style='display:none'>
        <span class='label-m-regular'></span>
        <button
          class='button button-primary button-primary--no-margin'
          data-ais-load-more-btn
        >
          <span class='button__label label-s-alternate'>
            ${ICON_BULLET}<span>${loadMoreLabel}</span>${ICON_BULLET}
          </span>
        </button>
      </div>`;
    hitsEl.querySelector("[data-ais-load-more-btn]")?.addEventListener("click", (event) => {
      if (event.currentTarget instanceof HTMLButtonElement) {
        event.currentTarget.blur();
      }
      onLoadMore();
    });
  }
  /**
   * Hook invoked after the first hits page renders, with the search query and
   * total hit count. No-op in the base class — the search page overrides this
   * to toggle its empty-state "Trending items" grid. The collection page keeps
   * the default behavior (full listing) and must NOT use this.
   */
  updateEmptyState(_query, _hitCount) {
  }
  renderFirstHitsPage(grid, { results }, cardAssets, noResultsTemplate, indexName) {
    const pageHits = results?.hits ?? [];
    this.renderedHits = pageHits;
    this.resolvedPushes = [];
    this.resolvedPlacedPushes = [];
    this.resolvedStories = [];
    this.resolvedGifts = null;
    this.gridState = {
      cardAssets,
      indexName,
      noResultsTemplate,
      query: results?.query ?? "",
      userData: results?.userData ?? []
    };
    this.renderHitsGrid(grid);
    void this.hydrateSearchPushes(grid, results?.userData ?? []);
    return pageHits.length;
  }
  appendHitsPage(grid, newHits, renderedCount) {
    if (newHits.length === 0) return renderedCount;
    this.renderedHits = [...this.renderedHits, ...newHits];
    this.renderHitsGrid(grid);
    return renderedCount + newHits.length;
  }
  /**
   * Equalizes meta / price across cards in each grid row.
   *
   * Ne touche PAS au `ResizeObserver`. Le déconnecter ici puis le ré-`observe()`
   * en sortie était une boucle infinie : `observe()` remet `lastReportedSize` à
   * zéro, donc l'étape de rendu suivante redélivrait un callback, qui réalignait,
   * qui ré-observait — un alignement complet à chaque frame, sans fin. Mesuré sur
   * la PLP : 6 rappels sur 6 frames, ~190 ms chacun, thread principal saturé en
   * permanence. Seule la réentrance est gardée.
   */
  alignHitsGridZones(grid) {
    if (this.isAligningZones) return;
    this.isAligningZones = true;
    try {
      alignProductCardZones(grid);
      predecodeHoverVisuals(grid);
    } finally {
      this.isAligningZones = false;
    }
  }
  /**
   * Observes the hits grid for viewport-driven width changes.
   * Stores `grid` on the instance so the observer never closes over a stale node
   * when InstantSearch replaces `[data-ais-grid]`.
   *
   * Garde en LARGEUR, même raison qu'à `gallery-main-product.ts` : l'alignement
   * ne dépend que de la largeur disponible (composition des rangées, retour à la
   * ligne), et il ne produit que des changements de HAUTEUR. Réagir à la hauteur
   * revenait à réagir à son propre effet.
   */
  bindHitsGridZoneAlignment(grid) {
    if (this.hitsGridForAlign === grid) return;
    this.hitsGridForAlign = grid;
    this.zoneAlignObserver?.disconnect();
    this.zoneAlignObserver ?? (this.zoneAlignObserver = new ResizeObserver((entries) => {
      const current = this.hitsGridForAlign;
      if (!current) return;
      const width = Math.round(entries[0]?.contentRect.width ?? 0);
      if (width === 0 || width === this.lastAlignedWidth) return;
      this.lastAlignedWidth = width;
      this.alignHitsGridZones(current);
    }));
    this.lastAlignedWidth = Math.round(grid.getBoundingClientRect().width);
    this.zoneAlignObserver.observe(grid);
  }
  /**
   * Le ResizeObserver rattrapait par accident le re-flow du chargement des
   * polices : la grille ne change pas de largeur quand une police bascule, mais
   * les libellés des cartes, si. Avec la garde en largeur, ce cas doit être
   * accroché explicitement — une fois, au boot.
   */
  realignOnFontsReady() {
    if (this.fontsAlignBound) return;
    this.fontsAlignBound = true;
    void document.fonts.ready.then(() => {
      const grid = this.hitsGridForAlign;
      if (grid) this.alignHitsGridZones(grid);
    });
  }
  /**
   * Même angle mort que les polices : le mode nuit recompose les rangées sans
   * toucher à la largeur de la grille. Sous `data-plp-night-strip`, les
   * produits sans média `Night vision` sont masqués (TP2-1815) — et les tuiles
   * éditoriales avant eux —, donc les cartes changent de rangée et les hauteurs
   * de méta et de prix égalisées pour les rangées de jour ne valent plus rien.
   * En grille 4, où la nuit garde le contenu des cartes, ça se voit.
   *
   * On écoute le marqueur sur `<html>` plutôt qu'un évènement du sélecteur
   * Jour/Nuit : il est posé par trois chemins (clic, script de boot, `sync()`),
   * et ce module ne doit rien savoir de l'autre.
   *
   * Le rappel est une microtâche : il tombe juste après `apply()`, qui pose le
   * marqueur et force le recalcul, et AVANT la frame qui arme le fondu. Le
   * réalignement fait donc partie du saut de mise en page, joué sec, et jamais
   * de l'animation.
   *
   * ⚠️ `attributeOldValue` n'est pas décoratif. `sync()` RÉÉCRIT le marqueur à
   * l'identique dans la frame du fondu, et une écriture à valeur égale émet
   * quand même un enregistrement. Sans comparaison, l'alignement — un reflow
   * forcé sur toute la grille — se rejouait en plein fondu pour un résultat
   * identique. Le premier enregistrement du lot porte la valeur d'avant le lot :
   * égale à la valeur courante, rien n'a bougé.
   */
  realignOnNightStrip() {
    if (this.nightStripObserver) return;
    const root = document.documentElement;
    this.nightStripObserver = new MutationObserver((records) => {
      if (records[0]?.oldValue === root.getAttribute("data-plp-night-strip")) {
        return;
      }
      const grid = this.hitsGridForAlign;
      if (grid) this.alignHitsGridZones(grid);
    });
    this.nightStripObserver.observe(root, {
      attributeFilter: ["data-plp-night-strip"],
      attributeOldValue: true
    });
  }
  /**
   * Single render path for the grid.
   *
   * Preact diffs against what is already on screen, so loading a further page
   * appends nodes instead of rebuilding the grid — the previous implementation
   * relied on `insertAdjacentHTML` for that, which worked but left the async
   * pushes to be spliced in imperatively afterwards. Cards are keyed by
   * objectID and their markup comes from a stable string, so the already
   * painted ones (including whatever `hydrateGiftProducts` wrote into them)
   * are left untouched.
   */
  renderHitsGrid(grid) {
    const state = this.gridState;
    if (!state) return;
    this.hitsGrid = grid;
    const hits = this.renderedHits;
    grid.classList.toggle("collection-grid", hits.length > 0);
    const hidePlaced = this.hasActiveRefinements();
    renderHitsGrid(grid, {
      cardAssets: state.cardAssets,
      gifts: this.resolvedGifts,
      hits,
      noResultsLabel: this.labels.noResults,
      noResultsTemplate: state.noResultsTemplate,
      collectionPushes: hidePlaced ? "" : this.readCollectionPushTemplate(),
      placedPushes: hidePlaced ? [] : this.resolvedPlacedPushes,
      stories: hidePlaced ? [] : this.resolvedStories.map(
        (story) => renderStoryList(story, this.readStoryAssets())
      ),
      pushes: [...getRulePushes(state.userData), ...this.resolvedPushes],
      query: state.query
    });
    this.alignHitsGridZones(grid);
    this.bindHitsGridZoneAlignment(grid);
    this.realignOnFontsReady();
    this.realignOnNightStrip();
    void this.hydrateGifts(grid, hits);
    void this.hydrateCartGifts(grid);
  }
  /**
   * Lit le panier pour savoir quels produits ont déjà reçu leur cadeau, et
   * re-rend si la grille a été peinte avec un état plus ancien.
   *
   * Même discipline que `hydrateGifts` : appelée DEPUIS le rendu, elle ne re-rend
   * que sur un vrai changement — sans quoi rendu et hydratation s'appelleraient
   * sans fin, en gelant l'onglet plutôt qu'en levant une erreur. Ici le garde-fou
   * est le numéro d'état, relu à chaque passage, et non un booléen rendu par le
   * rafraîchissement : InstantSearch enchaîne plusieurs rendus, leurs
   * hydratations attendent la même requête, et un booléen n'aurait été lu que par
   * la première à résoudre — celle-là même que le token fait taire quand un rendu
   * plus récent l'a périmée. La grille restait alors peinte avec l'ancien panier.
   *
   * Le numéro est enregistré AVANT de re-rendre : le rendu rappelle cette
   * méthode, qui trouve alors l'égalité et s'arrête.
   */
  async hydrateCartGifts(grid) {
    const token = this.cartGiftToken + 1;
    this.cartGiftToken = token;
    await refreshGiftedHandles();
    if (this.cartGiftToken !== token || !grid.isConnected) return;
    if (giftedVersion() === this.renderedGiftVersion) return;
    this.renderedGiftVersion = giftedVersion();
    this.renderHitsGrid(grid);
  }
  /**
   * Resolves the gifts only known by their parent GID and folds them into the
   * render. They used to be appended to each quick-buy form with
   * `insertAdjacentHTML`; a Preact-owned form drops nodes it does not own, so
   * they now travel as data and the inputs come from the vdom.
   */
  async hydrateGifts(grid, hits) {
    const token = this.giftToken + 1;
    this.giftToken = token;
    const gifts = await resolveGiftsForHits(hits, this.resolvedGifts);
    if (this.giftToken !== token || !grid.isConnected || !gifts) return;
    this.resolvedGifts = gifts;
    this.renderHitsGrid(grid);
  }
  /**
   * Resolves handle-based pushes and folds them into the rendered state.
   *
   * They used to be inserted straight into the DOM with `insertBefore`, which a
   * Preact-owned grid would drop on its next render. Going through state keeps
   * every node inside the vdom and makes the placement identical to the inline
   * pushes, since both now go through the same ordering.
   *
   * La liste résolue mêle deux types de metaobject : les tuiles visuelles
   * historiques, intercalées par `order`, et les `push_collection`, placées par
   * CSS. Elles voyagent séparément jusqu'à la grille.
   */
  async hydrateSearchPushes(grid, userData) {
    const config = readStorefrontConfig(this);
    if (!config || !hasSearchPushHandles(userData)) return;
    const token = this.pushToken + 1;
    this.pushToken = token;
    const { placed, rules, stories } = await resolveSearchPushes(
      config,
      userData
    );
    if (this.pushToken !== token || !grid.isConnected) return;
    if (!placed.length && !rules.length && !stories.length) return;
    this.resolvedPushes = rules;
    this.resolvedPlacedPushes = placed;
    this.resolvedStories = stories;
    this.renderHitsGrid(grid);
  }
  /**
   * Markup des pushes éditoriaux de la collection, rendu par Liquid dans un
   * `<template>` inerte — le même snippet que la grille legacy, donc le même
   * markup des deux côtés.
   *
   * Lu une seule fois : Liquid l'a rendu, il ne bouge pas d'une recherche à
   * l'autre. C'est ce qui le rend idéal pour `dangerouslySetInnerHTML`, que
   * Preact ne re-parse que si la chaîne change. Vide sur la page recherche.
   */
  readCollectionPushTemplate() {
    this.pushTemplateCache ?? (this.pushTemplateCache = this.querySelector(
      "template[data-push-collection]"
    )?.innerHTML.trim() ?? "");
    return this.pushTemplateCache;
  }
  /**
   * Une facette ou un tri est-il actif ?
   *
   * Un push éditorial décrit la collection entière. Dès qu'une facette ou un tri
   * est posé, la grille n'est plus cette collection mais une sélection dedans :
   * le push n'a plus de raison d'y figurer, et son placement explicite
   * (`grid-row` fixe) le laisserait de toute façon épinglé à une ligne que les
   * produits restants n'atteignent plus.
   *
   * Même définition que `stateToRoute` dans `routing.ts` — celle qui décide si
   * l'URL porte des paramètres. Les deux doivent rester d'accord : une URL sans
   * paramètre doit montrer les pushes, une URL qui en porte doit les masquer.
   *
   * Le filtre de collection lui-même n'en fait pas partie : il passe par
   * `filters`, pas par un refinement, donc il ne compte pas comme sélection.
   */
  hasActiveRefinements() {
    const state = this.getSearchHelper()?.state;
    if (!state) return false;
    const defaultIndex = this.config?.defaultSortBy || this.config?.indexName;
    if (defaultIndex && state.index && state.index !== defaultIndex) return true;
    const refined = [
      state.facetsRefinements,
      state.disjunctiveFacetsRefinements,
      state.hierarchicalFacetsRefinements
    ].some(
      (group) => Object.values(group ?? {}).some((values) => (values?.length ?? 0) > 0)
    );
    if (refined) return true;
    if ((state.tagRefinements?.length ?? 0) > 0) return true;
    return Object.values(state.numericRefinements ?? {}).some(
      (operators) => Object.keys(operators ?? {}).length > 0
    );
  }
  readNoResultsTemplate() {
    return this.querySelector(
      "template[data-ais-no-results]"
    )?.innerHTML.trim() ?? "";
  }
  updateHitsFooter(hitsEl, { isLastPage, results }, renderedCount) {
    const moreWrapper = hitsEl.querySelector(
      "[data-rerender-more]"
    );
    const countSpan = moreWrapper?.querySelector(".label-m-regular");
    const button = moreWrapper?.querySelector(
      "[data-ais-load-more-btn]"
    );
    const paginationNav = hitsEl.querySelector(
      "[data-ais-pagination]"
    );
    const totalHits = results?.nbHits ?? 0;
    const totalPages = results?.nbPages ?? 0;
    const currentPage = (results?.page ?? 0) + 1;
    const query = results?.query?.trim() ?? "";
    this.updateQueryUi(query);
    if (countSpan) {
      const showingItemsTemplate = this.dataset.productShowingItemsTemplate || "You have seen CURRENT_ITEMS of TOTAL_ITEMS";
      countSpan.textContent = renderedCount > 0 && totalHits > 0 ? showingItemsTemplate.replace("CURRENT_ITEMS", String(renderedCount)).replace("TOTAL_ITEMS", String(totalHits)) : "";
    }
    if (moreWrapper)
      moreWrapper.style.display = renderedCount === 0 ? "none" : "";
    if (button) button.style.display = isLastPage ? "none" : "";
    renderPagination(paginationNav, {
      buildPageUrl: (page) => this.buildPageUrl(page),
      currentPage,
      pageLabel: this.labels.page,
      totalPages
    });
    this.setNoResultsMessageVisible(Boolean(query && totalHits === 0));
  }
  /**
   * Only the bare, paginated collection is an indexable sequence: a refined view
   * serves the exact same source HTML, so it canonicalises onto the clean
   * collection and owns no prev/next. That is the rule
   * `snippets/seo-pagination-tags.liquid` applies server-side, and it has to be
   * applied here too — `setHeadLink('canonical')` overwrites the Liquid tag.
   */
  updatePaginationHeadTags(currentPageIndex, totalPages) {
    const currentPage = currentPageIndex + 1;
    this.removeHeadLink("prev");
    this.removeHeadLink("next");
    if (this.hasRefinedState()) {
      this.setHeadLink("canonical", this.buildSeoPageUrl(1));
      return;
    }
    this.setHeadLink("canonical", this.buildSeoPageUrl(currentPage));
    if (totalPages <= 1) return;
    if (currentPage > 1) {
      this.setHeadLink("prev", this.buildSeoPageUrl(currentPage - 1));
    }
    if (currentPage < totalPages) {
      this.setHeadLink("next", this.buildSeoPageUrl(currentPage + 1));
    }
  }
  /** `sort_by` is only written to the URL when it differs from the default. */
  hasRefinedState() {
    return Array.from(new URLSearchParams(window.location.search).keys()).some(
      (key) => key === "q" || key === "sort_by" || key.startsWith("filter.")
    );
  }
  setHeadLink(rel, href) {
    const selector = rel === "canonical" ? "link[rel='canonical']" : `link[rel='${rel}'][data-seo-pagination]`;
    let link = document.head.querySelector(selector);
    if (!link) {
      link = document.createElement("link");
      link.rel = rel;
      if (rel !== "canonical") link.dataset.seoPagination = "true";
      document.head.appendChild(link);
    }
    link.href = href;
  }
  /**
   * Only ever removes theme-owned prev/next: `snippets/seo-pagination-tags.liquid`
   * and `setHeadLink` both mark theirs with `data-seo-pagination`, so the selector
   * has to match. The unqualified `link[rel='next']` this replaces also swept away
   * tags rendered by an app.
   *
   * Sweeping the Liquid ones is deliberate: they are computed from the page the
   * server rendered, so they go stale the moment InstantSearch paginates
   * client-side. This runs before the `setHeadLink` calls, which re-emit the pair
   * for the current page — never a duplicate — and emit nothing at all on a
   * refined view.
   */
  removeHeadLink(rel) {
    document.head.querySelectorAll(`link[rel='${rel}'][data-seo-pagination]`).forEach((link) => link.remove());
  }
  /** Head tags: no refinement state, no foreign param, ever. */
  buildSeoPageUrl(page) {
    const url = new URL(window.location.pathname, window.location.origin);
    if (page > 1) url.searchParams.set("page", String(page));
    return url.href;
  }
  /**
   * Visible pagination links keep the refinement state — clicking “page 2” must
   * stay inside the filtered view. Tracking params (utm_*, fbclid, gclid…) now
   * persist in the URL and are dropped here: an internal link carrying them
   * re-attributes the session.
   */
  buildPageUrl(page) {
    const url = new URL(window.location.href);
    Array.from(url.searchParams.keys()).forEach((key) => {
      if (!isRoutingKey(key)) url.searchParams.delete(key);
    });
    if (page <= 1) {
      url.searchParams.delete("page");
    } else {
      url.searchParams.set("page", String(page));
    }
    return `${url.pathname}${url.search}${url.hash}`;
  }
  readInitialPageTarget() {
    const page = Number(new URLSearchParams(window.location.search).get("page"));
    if (!Number.isInteger(page) || page <= 1) return 1;
    return Math.min(page, ALGOLIA_MAX_INITIAL_PRELOAD_PAGES);
  }
  /**
   * Called on every search *and* on every render, so the writes are guarded:
   * setting `hidden` / `style.display` / `aria-hidden` unconditionally dirtied
   * three attributes per message per keystroke, which is the DOM churn that
   * shows up as the inspector repainting rules that never actually changed.
   */
  setNoResultsMessageVisible(isVisible) {
    const display = isVisible ? "" : "none";
    const ariaHidden = String(!isVisible);
    document.querySelectorAll("[data-ais-no-results-message]").forEach((message) => {
      if (message.hidden === isVisible) message.hidden = !isVisible;
      if (message.style.display !== display) {
        message.style.display = display;
      }
      if (message.getAttribute("aria-hidden") !== ariaHidden) {
        message.setAttribute("aria-hidden", ariaHidden);
      }
    });
  }
  setupSearchStateHandlers() {
    if (!this.search) return;
    this.search.mainHelper?.on("search", () => {
      this.setNoResultsMessageVisible(false);
      document.documentElement.classList.add("ais-searching");
    });
    let skeletonCleaned = false;
    this.search.on("render", () => {
      document.documentElement.classList.remove("ais-searching");
      if (skeletonCleaned) return;
      document.querySelectorAll("[data-ais-refinements] .ais-skel-group").forEach((element) => element.remove());
      skeletonCleaned = true;
    });
  }
  /**
   * Applies a "select all" / "deselect all" facet action as a single Algolia
   * request. Instead of clicking each checkbox (which makes the refinementList
   * widget call `.search()` once per value → N requests), we batch every
   * disjunctive-facet refinement onto the InstantSearch helper and trigger a
   * single `search()` — exactly like a single filter click does. Returns `false`
   * when the helper isn't available so the caller can fall back.
   */
  applyBulkFacetSelection(attribute, values, shouldSelect) {
    const helper = this.getSearchHelper();
    if (!helper || !attribute) return false;
    if (!helper.state?.disjunctiveFacets?.includes(attribute)) return false;
    let mutated = false;
    values.forEach((value) => {
      const isRefined = helper.state?.isDisjunctiveFacetRefined?.(attribute, value) ?? false;
      if (shouldSelect && !isRefined) {
        helper.addDisjunctiveFacetRefinement(attribute, value);
        mutated = true;
      } else if (!shouldSelect && isRefined) {
        helper.removeDisjunctiveFacetRefinement(attribute, value);
        mutated = true;
      }
    });
    if (mutated) helper.search();
    return true;
  }
  getSearchHelper() {
    const helper = this.search?.helper;
    if (helper && typeof helper.addDisjunctiveFacetRefinement === "function" && typeof helper.removeDisjunctiveFacetRefinement === "function" && typeof helper.search === "function") {
      return helper;
    }
    return null;
  }
  setupDialog() {
    const dialog = document.querySelector(
      "[data-filter-dialog]"
    );
    if (!dialog) return;
    const toggleDialog = () => {
      document.documentElement.classList.toggle("is-overflow-hidden");
      if (dialog.open) {
        dialog.close();
        return;
      }
      dialog.showModal();
    };
    const signal = this.controller?.signal;
    document.querySelectorAll("[data-btn-toggle-filter]").forEach((button) => {
      button.addEventListener("click", toggleDialog, { signal });
    });
    dialog.addEventListener(
      "click",
      (event) => {
        const rect = dialog.getBoundingClientRect();
        const inDialog = [
          rect.top <= event.clientY,
          event.clientY <= rect.top + rect.height,
          rect.left <= event.clientX,
          event.clientX <= rect.left + rect.width
        ].every(Boolean);
        if (!inDialog) toggleDialog();
      },
      { signal }
    );
    document.querySelector("[data-ais-dialog-close]")?.addEventListener(
      "click",
      () => {
        document.documentElement.classList.remove("is-overflow-hidden");
        dialog.close();
      },
      { signal }
    );
  }
};

// src/sections/algolia-main-collection/algolia-main-collection.ts
var AlgoliaCollectionPage = class extends AlgoliaPageBase {
  searchAnalyticsTags() {
    return ["collection-page"];
  }
  searchRuleContexts() {
    return ["collection"];
  }
  readConfig() {
    const {
      algoliaAppId,
      algoliaApiKey,
      algoliaIndexName,
      algoliaCollectionAttribute = "collections",
      algoliaCollectionId = "",
      algoliaCollectionHandle = "",
      algoliaFacets = "",
      algoliaHiddenFacets = "",
      algoliaDefaultSort: sectionDefaultSort = "",
      algoliaSort: sectionSort = ""
    } = this.dataset;
    const sortConfig = document.querySelector(
      "[data-ais-sort-config]"
    );
    const filterDefaultSort = sortConfig?.dataset.algoliaDefaultSort ?? "";
    const filterSort = sortConfig?.dataset.algoliaSort ?? "";
    const defaultSortValue = sectionDefaultSort || filterDefaultSort;
    if (!algoliaAppId || !algoliaApiKey || !algoliaIndexName) return null;
    const sortItems = this.withDefaultSortItem(
      this.mergeSortItems(sectionSort, filterSort),
      defaultSortValue
    );
    return {
      apiKey: algoliaApiKey,
      appId: algoliaAppId,
      collectionFilter: this.buildCollectionFilter(
        algoliaCollectionAttribute,
        this.resolveCollectionValue(
          algoliaCollectionAttribute,
          algoliaCollectionId,
          algoliaCollectionHandle
        )
      ),
      defaultSortBy: this.defaultSortBy(defaultSortValue, sortItems),
      facetPairs: parsePairs(algoliaFacets),
      hiddenFacets: parseHiddenFacets(algoliaHiddenFacets),
      indexName: algoliaIndexName,
      sortItems
    };
  }
  // The Algolia Shopify index carries both `collections` (handles) and
  // `collection_ids` (numeric ids), so the filter value follows the configured
  // facet attribute. Any other attribute name falls back to the id.
  resolveCollectionValue(attribute, collectionId, collectionHandle) {
    const cleanAttribute = attribute.trim();
    if (cleanAttribute === "collections" || /handle/i.test(cleanAttribute)) {
      return collectionHandle;
    }
    return collectionId;
  }
  buildCollectionFilter(attribute, collectionId) {
    const cleanAttribute = attribute.trim();
    const cleanCollectionId = collectionId.trim();
    if (!cleanAttribute || !cleanCollectionId) return "";
    if (/^\d+$/.test(cleanCollectionId)) {
      return `${cleanAttribute}:${cleanCollectionId}`;
    }
    return `${cleanAttribute}:"${cleanCollectionId.replace(/"/g, '\\"')}"`;
  }
};
if (!customElements.get("algolia-collection-page")) {
  customElements.define("algolia-collection-page", AlgoliaCollectionPage);
}
